const BUILDING_INSPECTION = {
  // help text shown in the info "i" next to inspection fields
  tooltips: {
    info: {
      buildingCategory:
        'Välj byggnadens huvudkategori, till exempel kontor, skola eller lager. Fältet används för att välja rätt standardvärden och profiler i beräkningen.',
      yearOfConstruction:
        'Ange byggnadens byggår, eller året för den senaste väsentliga ombyggnaden om det är mer representativt. Används bland annat för att bedöma sannolik teknisk standard.',
      numberOfFloors:
        'Ange det totala antalet våningar ovan mark för byggnaden. Fältet används som underlag för geometri, volym och vidare indelning i zoner.',
    },
    thermalZones: {
      zoneCategory:
        'En termisk zon är en del av byggnaden som behandlas samlat i beräkningen, vanligtvis med liknande användning och inneklimat. Ge zonen ett tydligt namn och välj zonkategori. Kategorin bestämmer standardprofiler för drifttid, interna laster och tekniska förutsättningar.',
      buildingSubcategory:
        'Välj underkategori om du vill ha en mer exakt klassificering av zonen. Lämna fältet tomt om vanlig zonkategori är tillräcklig.',
      zoneClimate:
        'Anger om zonen är uppvärmd, delvis uppvärmd eller ouppvärmd. Klimatstatusen avgör hur zonen ingår i uppvärmnings och kylbehovet och är en grundläggande förutsättning för energiberäkningen.',
      bra: 'BRA är zonens bruksarea, alltså golvarean innanför ytterväggarna som räknas som uppvärmd area. Ange BRA i m². Arean är en av de viktigaste indata och påverkar nästan alla beräkningar direkt.',
      floors:
        'Ange hur många våningar zonen sträcker sig över om den inte är begränsad till ett plan. Om zonen endast ligger på ett plan kan fältet ofta lämnas tomt.',
      floorHeight:
        'Ange genomsnittlig våningshöjd i meter för zonen. Används tillsammans med arean för att beräkna volym och luftmängder.',
      indoorTemp:
        'Temperaturen zonen har när simuleringen startar. Detta är inte ett börvärde: börvärdena för uppvärmning och kyla anges i Uppvärmningsschema och Kylschema.',
      tekStandard:
        'TEK är de norska byggtekniska föreskrifterna, till exempel TEK10 och TEK17, som ställer krav på bland annat U-värden och täthet. Välj relevant TEK-standard om du vill styra standardvärdena mer exakt än vad byggåret ensamt ger.',
      airLeakageN50:
        'Läckagetal (n50) beskriver hur lufttät byggnaden är, mätt som antal luftväxlingar per timme vid 50 Pa tryckskillnad. Ange värdet om det är känt från tryckprovning eller dokumentation. Om fältet är tomt används representativa standardvärden.',
      thermalBridgeCoeff:
        'En köldbrygga är ett ställe i konstruktionen med ökad värmeförlust, vanligtvis där bjälklag och väggar möter ytterkonstruktionen. Välj bärande konstruktion eller köldbryggekategori om du vill modellera köldbryggorna mer exakt. Används normalt bara när du har god byggnadsfysisk information.',
      thermalBridgePsiValue:
        'Normaliserat köldbryggevärde (ψ) uttrycker den samlade extra värmeförlusten från köldbryggor per m² golvarea. Ange värdet om det är känt från beräkning. Kan normalt lämnas tomt i en standardkartläggning.',
      heatingEmissionSystem:
        'Värmeavgivningssystemet är sättet värmen levereras till rummet på, till exempel radiator, konvektor eller golvvärme. Valet påverkar nödvändig framledningstemperatur och reglering. Nyttigt för detaljering, men behövs vanligtvis inte vid första registreringen.',
      coolingEmissionSystem:
        'Kylavgivningssystemet är sättet kylan levereras till rummet på, till exempel kylbaffel, fläktkonvektor eller kyltak. Valet påverkar temperaturnivå och reglering. Nyttigt för detaljering, men behövs vanligtvis inte vid första registreringen.',
      zoneConnections:
        'En zonkoppling beskriver en yta där två zoner, eller en zon och ett klimatförhållande, utbyter värme, till exempel en innervägg mot en kallare zon. Använd detta när sådant värmeutbyte är viktigt för modellen. Normalt endast aktuellt vid mer detaljerad uppsättning.',
      connectionArea:
        'Ange arean i m² för ytan som kopplar zonerna. Tillsammans med U-värdet bestämmer den hur mycket värme som utbyts. Fylls bara i när du faktiskt modellerar en zonkoppling.',
      connectionUValue:
        'U-värdet beskriver hur väl ytan mellan zonerna isolerar (W/m²K). Ange det om du har det tillgängligt. Annars kan kopplingen vanligtvis förenklas eller utelämnas.',
      heatingSchedule:
        'Ett uppvärmningsschema beskriver hur börvärde och drift varierar över dygnet och veckan, till exempel nattsänkning. Använd det när zonen har avvikande drift. Ger en mer realistisk simulering än fasta standardprofiler.',
      hasFloorToGround:
        'Aktivera detta om zonen har golv mot mark. Avaktivering döljer elementet och tar bort den lagrade arean från energiberäkningen.',
      hasRoof:
        'Aktivera detta om zonen har yttertak mot det fria. Avaktivering döljer elementet och tar bort den lagrade arean från energiberäkningen.',
      isBasement:
        'Aktivera detta när zonen är en källare under mark. Värmeförlusten mot marken beräknas då från elementet Källarkonstruktion, och yttertak, golv mot mark, ytterväggar, fönster och dörrar på denna zon lämnas utanför energiberäkningen.',
      basement: {
        area: 'Ange källarens golvarea mot mark i m². Arean krävs för att beräkna värmeförlusten mot marken och är normalt lika med BRA för källarzonen.',
        wallPerimeter:
          'Ange längden i meter av källarvägg som gränsar mot marken. Tillsammans med arean ger den golvets karakteristiska dimension. Lämnas fältet tomt antas en kvadratisk grundyta.',
        fillHeight:
          'Ange det genomsnittliga djupet från marknivå ned till källargolvet i meter. Avgör hur stor del av väggen som avger värme till marken. 0 betyder platta på mark.',
        wallThickness:
          'Ange källarväggens totala tjocklek vid marknivå i meter, inklusive isolering. 0,3 m används när fältet lämnas tomt.',
        wallConstructionType:
          'Välj källarväggens konstruktion under mark, eller en TEK period för att använda dess krav. Valet föreslår U-värde.',
        wallUValue:
          'U-värdet för källarväggens konstruktion under mark (W/m²K). Ange det om du känner det från dokumentation, annars används det föreslagna värdet.',
        floorConstructionType:
          'Välj källargolvets konstruktion mot marken, eller en TEK period för att använda dess krav. Valet föreslår U-värde.',
        floorUValue:
          'U-värdet för källargolvets konstruktion mot marken (W/m²K). Ange det om du känner det från dokumentation, annars används det föreslagna värdet.',
      },
      floor: {
        type: 'Typen av golv mot mark beskriver hur golvet mot mark eller mot ouppvärmt utrymme är uppbyggt, till exempel platta på mark eller golv över källare. Välj den som bäst beskriver konstruktionen. Valet används för att föreslå relevanta standardvärden, bland annat U-värde.',
        area: 'Ange arean för golv mot mark i m² för den del av zonen som ska registreras. Arean behövs för att beräkna värmeförlust genom golvet.',
        uValue:
          'U-värdet anger hur mycket värme som släpps igenom konstruktionen per m² och grad temperaturskillnad (W/m²K). Ett lägre värde betyder bättre isolering. Ange det om du känner till det från dokumentation eller beräkning, annars används nominella värden utifrån vald typ och år.',
      },
      structuralNodes: {
        boundary:
          'En strukturell nod är ett ställe där byggdelar möts, till exempel mellan bjälklag och yttervägg, och är vanligtvis en köldbrygga med extra värmeförlust. Använd strukturella noder när du vill registrera sådana detaljer. Normalt endast aktuellt vid högre detaljnivå.',
        length:
          'Ange längden för den aktuella noden eller köldbryggan i meter. Fylls endast i om strukturella noder används.',
        height:
          'Ange höjden för den aktuella noden i meter om relevant. Används tillsammans med övriga mått för en detaljerad geometribeskrivning.',
        width:
          'Ange bredden för den aktuella noden i meter om relevant. Fältet används endast vid detaljerad registrering av strukturella noder.',
      },
      roof: {
        angle:
          'Taklutningen är takytans lutning i grader, där 0 betyder platt tak. Den registreras för besiktningen, men energiberäkningen använder den inte ännu: värmeförlusten genom taket beräknas från area och U-värde, och takfönster får ingen solinstrålning i beräkningen.',
        type: 'Takkonstruktionen beskriver hur yttertaket är uppbyggt, till exempel kompakt tak, ventilerat snedtak eller takstolar. Välj den som bäst beskriver yttertaket. Valet ligger till grund för standard U-värde och övriga förutsättningar.',
        area: 'Ange takarea i m² som ingår i zonen. Arean behövs för att beräkna transmission genom yttertaket.',
        uValue:
          'U-värdet anger hur mycket värme som släpps igenom takkonstruktionen per m² och grad temperaturskillnad (W/m²K). Ett lägre värde betyder bättre isolering. Ange det om det är känt, annars används ett nominellt värde utifrån vald konstruktion och ålder.',
        glassType:
          'Aktivera detta om yttertaket har fönster eller takfönster, och välj glastyp. Glastypen, till exempel två eller tre glas, bestämmer både värmeförlust och hur mycket solenergi som släpps in genom takytan.',
        windowArea:
          'Ange total fönster- eller takfönsterarea i m². Fältet är endast relevant om yttertaket faktiskt har fönster eller takfönster.',
        windowUValue:
          'U-värdet för takfönstren anger värmeförlusten genom själva glaset och karmen (W/m²K). Ett lägre värde betyder bättre isolering. Ange det om det är känt, annars är standardvärden ofta tillräckliga.',
        gValue:
          'G-värdet (solfaktor) beskriver hur stor andel av solenergin som släpps igenom glaset, från 0 till 1. Ett högt g-värde ger mer gratis solvärme på vintern, men också ett större kylbehov på sommaren.',
        externalBlindsGt:
          'Utvändiga persienner sitter på utsidan av glaset och minskar solinstrålningen effektivt. Solfaktorn (gt) beskriver hur mycket solenergi som släpps igenom när avskärmningen är aktiv. Registrera detta när sådan solavskärmning har tydlig effekt.',
        externalScreenGt:
          'En utvändig duk eller screen är en utvändig textilavskärmning som dämpar solinstrålning. Solfaktorn (gt) anger hur mycket solenergi som släpps igenom med duken nere. Fylls bara i om lösningen finns i byggnaden.',
        internalShadingGt:
          'Invändig solavskärmning, till exempel persienner eller gardiner på insidan, dämpar solen men mindre effektivt än utvändig avskärmning. Solfaktorn (gt) beskriver kvarvarande solinsläpp. Används för att förbättra beräkningen av soltillskott.',
      },
      groundConditions: {
        type: 'Grundförhållanden beskriver massorna under byggnaden, till exempel lera, sand eller berg, som påverkar värmeförlusten mot marken. Använd detta när du har specifik information om marken. Detta är vanligtvis ett detaljfält.',
        thermalConductivity:
          'Värmekonduktivitet (λ) anger hur väl marken leder värme, i W/mK. Ett högre värde ger större värmeförlust mot marken. Ange ett dokumenterat värde om du har det, annars kan fältet lämnas tomt.',
        heatCapacity:
          'Värmekapaciteten beskriver hur mycket värme marken kan lagra och dämpar svängningar i värmeförlusten över tid. Ange den om den är känd. Kan normalt lämnas tom i en vanlig energikartläggning.',
        penetrationDepth:
          'Periodiskt inträngningsdjup är djupet i marken som påverkas av årstidsvariationer i temperatur. Det används i mer detaljerade markmodeller. Fältet behövs vanligtvis inte vid standardregistrering.',
      },
      internalLoads: {
        lighting:
          'Belysning är en intern värmelast: energin som ljuskällorna använder hamnar till stor del som värme i zonen. Registrera belysningsnivå och eventuella driftprofiler. Detta påverkar både elanvändning och kylbehov.',
        equipment:
          'Teknisk utrustning som datorer, skärmar och annan fast utrustning avger värme till rummet utöver att använda el, och är därför en intern värmelast. Registrera typisk effekt och driftprofil för zonen.',
        occupancy:
          'Personer avger värme och fukt och påverkar samtidigt ventilationsbehovet. Registrera personbelastning genom antal och profiler eller en standarduppsättning som beskriver normal användning av zonen.',
        dishwasher:
          'Markera diskmaskin om den är en relevant last i zonen. Andelen på varmvatten anger hur stor del av förbrukningen som täcks av uppvärmt tappvatten i stället för att maskinen värmer det själv. Används normalt bara när vitvaror är betydande.',
        washingMachine:
          'Markera tvättmaskin om den är en relevant last i zonen. Andelen på varmvatten anger hur stor del av vattnet maskinen hämtar från varmvattensystemet i stället för att värma det själv.',
        tumbleDryer:
          'Markera torktumlare om den är en relevant last i zonen. En eventuell andel på varmvatten beskriver hur stor del av energibehovet som täcks via varmt tappvatten i stället för direkt el.',
      },
      thermalMass: {
        heatCapacityCategory:
          'Termisk massa är byggnadens förmåga att lagra värme, vilket dämpar temperatursvängningar och förskjuter värme och kylbehov i tid. Välj värmekapacitetskategori, till exempel lätt eller tung konstruktion, om du vill justera detta utöver standardvärden.',
        normalizedHeatCapacity:
          'Normaliserad värmekapacitet uttrycker hur mycket värme zonen kan lagra per m² golvarea (Wh/m²K). Ange ett mer exakt värde om du har det, annars kan fältet lämnas tomt och kategorin används.',
        cladding:
          'Invändig beklädnad, till exempel gips, trä eller exponerad betong, påverkar hur mycket av den termiska massan som faktiskt är aktiv mot rummet. Välj typ om du vill ha en mer detaljerad beskrivning.',
        heatCapacity:
          'Ange värmekapaciteten för innerväggar om den är känd. Detta beskriver hur mycket värme de inre konstruktionerna kan lagra och används endast vid mer detaljerad modellering av termisk massa.',
        furnitureGrade:
          'Möbler och inredning bidrar också till termisk massa. Välj möbleringsgrad som beskriver hur möblerad zonen är om detta har betydelse. Fältet är normalt ett detaljfält.',
        massFactor:
          'Massfaktorn justerar hur mycket möbler och inredning bidrar till zonens termiska massa. Ange ett värde om du vill åsidosätta standardvärdet.',
      },
      exteriorWall: {
        direction:
          'Väderstrecket avgör hur mycket sol fasaden tar emot och hur vind och uteklimat påverkar värmeförlusten. Välj riktning, till exempel norr, söder, öster eller väster, för väggen som registreras.',
        type: 'Väggtypen beskriver hur ytterväggen är uppbyggd, till exempel regelvägg, murverk eller betong med isolering. Välj den som bäst beskriver väggen. Valet används för att föreslå relevanta standardvärden.',
        area: 'Ange ytterväggens bruttoarea i m², inklusive fönster, dörrar och portar. Beräkningen drar själv av öppningarna som är registrerade på väggen, så nettoarea ger för liten värmeförlust genom väggen.',
        uValue:
          'U-värdet anger hur mycket värme som släpps igenom väggen per m² och grad temperaturskillnad (W/m²K). Ett lägre värde betyder bättre isolering. Ange det om det är känt, annars används nominella värden utifrån väggtyp och ålder.',
        windowShadingFactor:
          'Andelen direkt solljus som fönstret förlorar på grund av skuggning från utsprång, grannbyggnader eller terräng, från 0 till 1. 0 betyder ingen skuggning och 1 betyder helt skuggat. Bara direkt sol minskas, inte diffus strålning. Persienner och screens nedan registreras men används inte i beräkningen.',
      },
      heatingCooling: {
        name: 'Ge utrustningen ett tydligt namn som gör det enkelt att skilja komponenter från varandra. Namnet används främst för identifiering i projektet.',
        type: 'Typen beskriver vilken sorts värme- eller kylenhet detta är, till exempel radiator, golvvärme, värmepump eller kylbaffel. Valet styr vilka fält som är relevanta och hur systemet modelleras.',
        energySource:
          'Energikällan är vad enheten använder för att producera värme eller kyla, till exempel elektricitet, fjärrvärme eller en värmepump. Välj källa om komponenten är direkt kopplad till en specifik källa, annars kan energiförsörjningen beskrivas centralt.',
        co2eEmissionFactor:
          'CO₂e-utsläppsfaktorn anger hur mycket växthusgasutsläpp som följer med energin enheten använder, angivet per kWh. Ange ett specifikt värde om du vill beräkna utsläpp exakt. Den påverkar inte själva energibehovet.',
        quantity:
          'Ange antal likadana enheter om flera identiska enheter är installerade. Kan lämnas tomt om effekten anges samlat.',
        power:
          'Nominell effekt är enhetens maximala värme- eller kyleffekt i kW. Den används för att bedöma om systemet har kapacitet att täcka behovet och hur flera system prioriteras. Ange samlad effekt om flera likadana enheter slås ihop.',
        systemEfficiency:
          'Systemverkningsgraden beskriver hur stor del av tillförd energi som faktiskt blir nyttig värme eller kyla, inklusive förluster i distribution och reglering. Ange ett bättre tal än standard om du har det. Ofta inte nödvändigt vid första registreringen.',
        priority:
          'Prioriteten styr ordningen som systemen tas i bruk när flera täcker samma behov. Lägre prioritet betyder att systemet används först, och resten täcker spetslast. Ange detta om zonen har flera värme- eller kylkällor.',
        cop: 'COP (Coefficient of Performance) är värmepumpens verkningsgrad för uppvärmning: förhållandet mellan levererad värme och tillförd el. En COP på 3 betyder tre gånger så mycket värme som el. Ange ett specifikt värde om du har det.',
        eer: 'EER (Energy Efficiency Ratio) är verkningsgraden för kyla: förhållandet mellan levererad kyla och tillförd el. Ett högre värde betyder effektivare kyla. Ange ett specifikt värde om du har det.',
        nominalLoad:
          'Nominell last (0-1) beskriver vilken andel av full kapacitet enheten är dimensionerad att köra på normalt. Detta är ett detaljfält och kan vanligtvis lämnas på standardvärdet.',
        minimumLoad:
          'Minimilast (0-1) är den lägsta andel av full kapacitet enheten kan köra stabilt på innan den måste slå av och på. Ange ett värde om du vill åsidosätta standarden.',
        degradeCoeff:
          'Degraderingskoefficienten (0-1) beskriver hur mycket verkningsgraden sjunker när enheten kör på dellast i stället för full effekt. Inverterstyrda enheter har vanligtvis lägre förluster. Sätts ofta automatiskt.',
        maxTemperatureSupplied:
          'Maximal framledningstemperatur är den högsta temperatur enheten kan leverera till värmeavgivningssystemet. Den avgör om enheten klarar att täcka temperaturbehovet, till exempel för radiatorer som kräver hög framledningstemperatur.',
      },
      domesticHotWater: {
        name: 'Ge tappvattenkomponenten ett tydligt namn om du registrerar flera enheter eller delsystem.',
        heaterType:
          'Värmetypen beskriver hur tappvattnet värms upp, till exempel direkt elvärmare, värmepump eller central försörjning som fjärrvärme. Valet påverkar både energibehov och utsläpp för varmt tappvatten.',
        tapFrequency:
          'Tappfrekvensen beskriver hur ofta och hur mycket varmt vatten som tappas, och speglar faktiskt användningsmönster i zonen. Den är en viktig drivkraft för det beräknade energibehovet för tappvatten.',
        tapCyclesPerDay:
          'Antal tappcykler per dygn är hur många gånger varmt vatten tappas under ett dygn. Ange ett värde om du vill åsidosätta standardprofilen med ett mer exakt tal.',
        thermalZone:
          'Koppla tappvattensystemet till den termiska zon det betjänar. Detta placerar energianvändningen och eventuell värmeavgivning rätt i modellen.',
      },
      productionEquipment: {
        name: 'Ge produktionsutrustningen ett tydligt namn. Används för att identifiera lasten i projektet och i rapporter.',
        energySource:
          'Energikällan är vad produktionsutrustningen använder, till exempel elektricitet eller gas. Den används för att fördela energianvändning på rätt bärare och för eventuell utsläppsberäkning.',
        power:
          'Nominell effekt är utrustningens typiska effektuttag i kW. Tillsammans med driftsschemat ger den underlag för att beräkna energianvändning och värmeavgivning till zonen.',
        eligibleForHarvesting:
          'Energiåtervinning innebär att utnyttja överskottsvärme från utrustningen till andra ändamål, till exempel uppvärmning. Kryssa i om utrustningen avger sådan överskottsenergi, så bedöms återvinningspotentialen.',
        operationalSchedule:
          'Driftsschemat beskriver när utrustningen faktiskt är i bruk under dygnet och veckan. Lägg in det om utrustningen inte följer normal drifttid, för en mer realistisk beräkning av energianvändning och interna laster.',
      },
      hvac: {
        name: 'Ge ventilationsaggregatet ett tydligt namn. Namnet används för identifiering om byggnaden har flera aggregat.',
        linkedZones:
          'Kopplade zoner är de termiska zoner ventilationsaggregatet betjänar med luft. Valet är nödvändigt för att fördela luftmängder, fläktenergi och värmeåtervinning korrekt mellan zonerna.',
        flowSfpSettings:
          'Här anger du aggregatets luftmängder och SFP-förutsättningar. SFP (specifik fläkteffekt) uttrycker hur mycket elektrisk effekt fläktarna använder per luftmängd, och är kärninformation för ventilationsberäkningen.',
        motorType:
          'Motortypen, till exempel AC eller EC, påverkar fläktens verkningsgrad och hur effekten ändras vid dellast. Välj typ om den är känd för en mer exakt beräkning.',
        sfp100:
          'SFP (specifik fläkteffekt) är förhållandet mellan fläktarnas effektuttag och luftmängden, angivet i kW per m³/s. Lägre SFP betyder en mer energieffektiv fläkt. Ange värdet vid 100 % drift, detta är huvudparametern i ventilationsberäkningen.',
        sfp80:
          'SFP vid 80 % drift beskriver specifik fläkteffekt när aggregatet körs på reducerad luftmängd. Ange den om du har dellastdata, annars kan fältet lämnas tomt.',
        sfp60:
          'SFP vid 60 % drift beskriver specifik fläkteffekt vid lägre luftmängd. Används endast vid mer detaljerad modellering av dellast.',
        sfp40:
          'SFP vid 40 % drift. Ange den om dellastdata för så låg luftmängd är tillgängligt.',
        sfp20:
          'SFP vid 20 % drift. Ange den om dellastdata för så låg luftmängd är tillgängligt.',
        fanPowerIn:
          'Fläkteffekt tilluft är tilluftsfläktens elektriska effektuttag i kW. Ange den om du har den separat. Kan normalt lämnas tomt när SFP är registrerat, eftersom effekten då beräknas därifrån.',
        fanPowerOut:
          'Fläkteffekt frånluft är frånluftsfläktens elektriska effektuttag i kW. Ange den om du har den separat. Används endast vid mer detaljerad registrering.',
        coverageArea:
          'Täckningsarea är golvarean aggregatet betjänar i m². Ange den om aggregatet endast täcker en del av byggnaden eller zonen. Kan ofta härledas från anslutna zoner.',
        coverageVolume:
          'Täckningsvolym är luftvolymen aggregatet betjänar i m³. Ange den om den är känd. Används som detaljfält vid ventilationsdimensionering.',
        airVolumeOperating:
          'Tilluftmängd i drift är luftmängden aggregatet levererar under normal drift, i m³/h. Detta är en central input för ventilationsbehov, fläktenergi och värme- och kylbatterier.',
        airVolumeCapacity:
          'Tilluftkapacitet är maximal luftmängd aggregatet kan leverera, i m³/h. Ange den om den är känd. Användbart för kapacitetsbedömningar, men inte alltid nödvändigt.',
        airVolumeNonOperating:
          'Tilluftmängd utanför drift är luftmängden aggregatet levererar när byggnaden inte används, till exempel vid reducerad nattdrift. Ange den om aggregatet går med reducerad luftmängd delar av tiden.',
        airVolumeExtractionOperating:
          'Frånluftmängd i drift är luften aggregatet drar ut ur zonerna under normal drift, i m³/h. Tillsammans med tilluftmängden beskriver den aggregatets faktiska luftbalans och påverkar fläktenergi och värmeåtervinning.',
        airVolumeExtractionCapacity:
          'Frånluftkapacitet är maximal luftmängd aggregatet kan dra ut, i m³/h. Ange den om den är känd. Användbart för kapacitetsbedömningar, men inte alltid nödvändigt.',
        airVolumeExtractionNonOperating:
          'Frånluftmängd utanför drift är luften aggregatet drar ut när byggnaden inte används, till exempel vid nattsänkning eller reducerad drift. Ange den om aggregatet går med reducerad luftmängd delar av tiden.',
        supplyTemperature:
          'Tillufttemperaturen är temperaturen på luften aggregatet blåser in i zonen, i °C. Börvärdena i driftschemat har företräde: detta värde används bara för timmar där schemat saknar börvärde. Ändra börvärdet för tilluft i driftschemat.',
        heatRecoveryType:
          'Värmeåtervinning återanvänder värmen i frånluften för att förvärma tilluften, vilket minskar uppvärmningsbehovet. Välj den typ som är installerad, till exempel roterande växlare, plattvärmeväxlare eller batteriåtervinning. Valet är viktigt för beräkningen av återvunnen energi.',
        efficiencyHR:
          'Verkningsgraden anger hur stor andel av värmen i frånluften som återvinnaren faktiskt överför till tilluften, i procent. Ett högre värde betyder mindre uppvärmningsbehov. Ange ett dokumenterat värde om du har det, annars används ett standardvärde utifrån vald typ.',
        frostProtection:
          'Frostskydd förhindrar att återvinnaren fryser igen vid låga utetemperaturer, men kan under perioder minska hur mycket värme som återvinns. Markera detta om aggregatet har frostskydd som påverkar drift eller värmeåtervinning. Användbart vid mer exakt modellering.',
        frostProtectionTemperature:
          'Detta är utetemperaturen då frostskyddet aktiveras. Under denna temperatur minskas eller styrs återvinningen för att undvika isbildning. Ange värdet om det är känt, annars används ett standardvärde.',
        measuredSupplyTemp:
          'Uppmätt tillufttemperatur är den faktiska temperaturen på luften aggregatet blåser in, registrerad vid en besiktning eller loggning. Ange den om du har fältmätningar. Används för kvalitetssäkring och mer exakt kalibrering av modellen.',
        measuredExhaustTemp:
          'Uppmätt frånlufttemperatur är den faktiska temperaturen på luften som dras ut ur zonerna, registrerad vid fältmätning. Ange den om du har sådana mätningar. Tillsammans med uppmätt tillufttemperatur används den för kvalitetssäkring.',
        dx: {
          name: 'Ett DX-system (direkt expansion) är ett kyl- eller värmepumpsbatteri där köldmediet förångas direkt i luftströmmen, utan en vattenkrets emellan. Ge enheten ett tydligt namn för identifiering om aggregatet har en sådan integrerad DX-enhet.',
          type: 'Typen anger vad DX-enheten kan göra: enbart kyla, enbart värme, eller båda (värmepumpsfunktion). Valet styr vilka effekt- och verkningsgradsfält som är relevanta.',
          heatingEffect:
            'Värmeeffekten är den maximala värme DX-enheten kan leverera till luften, i kW. Ange den om systemet levererar värme. Kan lämnas tom om enheten bara används för kyla.',
          coolingEffect:
            'Kyleffekten är den maximala kyla DX-enheten kan leverera till luften, i kW. Detta är normalt det viktigaste kapacitetsvärdet för kyldrift.',
          seasonalCop:
            'Säsongs-COP är DX-enhetens genomsnittliga verkningsgrad för uppvärmning över en säsong: förhållandet mellan levererad värme och tillförd el. Ange den om enheten också används för uppvärmning. Använd standardvärde om exakt dokumentation saknas.',
          seasonalEer:
            'Säsongs-EER är DX-enhetens genomsnittliga verkningsgrad för kyla över en säsong: förhållandet mellan levererad kyla och tillförd el. Ange den om den är känd. Används för att beräkna elanvändning för kyla.',
          systemEfficiency:
            'Beräkningen använder systemverkningsgraden som DX-enhetens egen verkningsgrad, i procent: 300 % betyder tre gånger så mycket värme eller kyla som el. Fälten för säsongs-COP/EER används inte ännu, så ange COP eller EER här som procent. Lämnas fältet tomt används 100 %.',
          energySource:
            'Energikällan är vad DX-enheten använder för att producera värme eller kyla, normalt elektricitet. Den används för energifördelning och eventuell utsläppsberäkning.',
        },
        heatingBattery: {
          name: 'Ett värmebatteri i ventilation är en värmeväxlare i aggregatet som värmer upp tilluften, vanligtvis matad med varmvatten från en panna eller värmepump, eller elektrisk. Ge batteriet ett tydligt namn om flera batterier finns i samma aggregat eller byggnad.',
          type: 'Batteritypen anger hur värmen tillförs, till exempel vattenburen (varmvatten genom batteriet) eller elektrisk. Valet påverkar energikälla och verkningsgrad.',
          power:
            'Effekten är den maximala värme batteriet kan tillföra tilluften, i kW. Används för kapacitetskontroll och energiberäkning.',
          systemEfficiency:
            'Systemverkningsgraden fångar upp förluster i distribution och reglering fram till batteriet. Ange ett värde om du har ett bättre tal än standard, annars kan fältet lämnas tomt.',
          energySource:
            'Energikällan är vad som förser värmebatteriet med värme, till exempel fjärrvärme, panna, värmepump eller elektricitet. Den används för energifördelning och eventuell utsläppsberäkning.',
        },
        coolingBattery: {
          name: 'Ett kylbatteri i ventilation är en värmeväxlare i aggregatet som kyler ned tilluften, vanligtvis matad med kallvatten från en kylmaskin eller via direkt expansion (DX). Ge batteriet ett tydligt namn om flera batterier finns.',
          type: 'Typen anger hur kylan tillförs, till exempel vattenburen (kallvatten genom batteriet) eller DX (direkt expansion). Valet påverkar energikälla och verkningsgrad.',
          power:
            'Effekten är den maximala kyla batteriet kan tillföra tilluften, i kW. Används för kapacitetskontroll och energiberäkning.',
          systemEfficiency:
            'Systemverkningsgraden fångar upp ytterligare förluster i distribution och reglering utöver den nominella prestandan. Ange ett värde om du vill ta med sådana förluster, annars kan fältet lämnas tomt.',
          eer: 'EER (Energy Efficiency Ratio) är kylbatteriets verkningsgrad: förhållandet mellan levererad kyla och tillförd el. Ange den om den är känd. Används för att beräkna elektrisk energianvändning vid kyla.',
          energySource:
            'Energikällan är vad som förser kylbatteriet med kyla, till exempel kylmaskin, fjärrkyla eller DX. Den används för energifördelning och eventuell utsläppsberäkning.',
        },
        naturalVentilation:
          'Naturlig ventilation är luftutbyte som drivs av vind och temperaturskillnader genom fönster, ventiler eller schakt, utan fläktar. Aktivera detta om zonen eller aggregatet har naturlig ventilation som ska ingå i modellen.',
        operationalSchedule:
          'Ett driftschema beskriver när ventilationen är i drift över dygnet och veckan. Lägg in ett schema för naturlig ventilation eller aggregatdrift om driften avviker från standarddrifttid.',
        operationalScheduleExtra:
          'Använd ett extra schema när samma aggregat eller ventilationsfunktion har flera driftperioder med olika drift, till exempel säsongsvis. Varje schema täcker en egen period.',
      },
      centralEnergy: {
        name: 'En central energimodul är en gemensam energicentral som försörjer flera zoner eller funktioner, till exempel en värmecentral eller kylmaskinscentral. Ge den ett tydligt namn. Namnet används endast för identifiering.',
        mode: 'Läget anger om centralen levererar uppvärmning, kyla, varmvatten eller kombinationer av dessa. Detta är en grundläggande inställning som styr hur centralen används i modellen.',
        thermalZone:
          'En central kan kopplas till en termisk zon så att omgivningstemperaturen runt centralen följer zonen, vilket påverkar verkningsgrad och förluster. Koppla den till en relevant zon om placering eller omgivningstemperatur är viktig för beräkningen, annars kan den stå som fristående.',
        ambientTemperature:
          'Omgivningstemperaturen är temperaturen i utrymmet där centralen står, till exempel ett teknikrum. Den används endast när centralen inte är kopplad till en termisk zon och påverkar värmeförluster från centralen och lagringstankar. Om en zon väljs hämtas temperaturen därifrån i stället.',
        sourceName:
          'Ge energikällan ett tydligt namn så att den är lätt att känna igen om centralen har flera energikällor. Namnet används endast för identifiering.',
        usage:
          'Dessa val styr vad energikällan faktiskt täcker: uppvärmning, kyla och/eller tappvarmvatten (VVT). Välj de behov källan bidrar till. Inverterstyrd betyder att enheten kan modulera effekten, vilket ger bättre verkningsgrad vid dellast.',
        heatPump: {
          type: 'Värmepumpstypen beskriver var värmepumpen hämtar och avger energi: luft-vatten tar energi från uteluft och levererar till vattenburen värme, vätska-vatten hämtar från mark, berg eller vatten via en kollektor, och luft-luft värmer inneluften direkt. Valet påverkar verkningsgrad och vilka tilläggsfält som visas.',
          co2eEmissionFactor:
            'CO₂e-utsläppsfaktorn anger hur mycket växthusgasutsläpp som följer med energin värmepumpen använder, angivet per kWh. Ange ett specifikt värde endast om du vill beräkna utsläpp exakt. Den påverkar inte själva energibehovet.',
          heatingCapacity:
            'Värmekapaciteten är värmepumpens nominella värmeeffekt i kW, alltså hur mycket värme den kan leverera under normala förhållanden. Detta är det viktigaste kapacitetsvärdet och används för att bedöma om pumpen täcker värmebehovet.',
          nominalLoad:
            'Nominell last (0-1) är den andel av full kapacitet värmepumpen är dimensionerad att köra på normalt. Ange den om dokumentationen anger den separat. Används vid detaljerad dellastmodellering.',
          minimumLoad:
            'Minimilast (0-1) är den lägsta andel av full kapacitet värmepumpen kan köra stabilt på innan den måste slå av och på. Ange den om pumpen kan modulera och detta är känt.',
          degradeCoeff:
            'Degraderingskoefficienten (0-1) beskriver hur mycket verkningsgraden sjunker när värmepumpen kör på dellast i stället för full effekt. Ange den om tillverkardata eller beräkningar finns. Kan normalt lämnas tomt, då sätts den till 0,8 enligt NS 3031, eller 0,6 för inverterstyrda enheter.',
          maxTemperatureSupplied:
            'Högsta levererad temperatur är den varmaste framledningstemperatur värmepumpen kan leverera till värmesystemet, i °C. Värmepumpar får lägre verkningsgrad vid hög framledningstemperatur. Används för att bedöma om pumpen täcker temperaturbehovet, till exempel för radiatorer som kräver hög temperatur.',
          cop: 'COP (Coefficient of Performance) är värmepumpens verkningsgrad för uppvärmning: förhållandet mellan levererad värme och tillförd el. En COP på 3 betyder tre gånger så mycket värme som el. Ange ett specifikt värde om du har det, annars används standardvärden.',
          liquidSource:
            'Vätskekällan är mediet som vätska-vatten-värmepumpen hämtar energi från via en kollektor, till exempel mark, berg, sötvatten eller havsvatten. Källan påverkar tillgänglig källtemperatur och därmed verkningsgraden.',
          sourceTemperature:
            'Källtemperaturen är temperaturen på vätskan som kommer från källan in till värmepumpen, i °C. Högre källtemperatur ger bättre verkningsgrad. Ange den om den är känd från mätning eller markundersökning.',
          sourceYearlyAverageTemperature:
            'Årsmedeltemperaturen är källans genomsnittstemperatur över ett år, i °C. Den används som utgångspunkt för att beräkna värmepumpens säsongsprestanda. Ange den om den är känd, annars används typiska värden för vald källa.',
          liquidMaxTemperature:
            'Detta är den högsta temperatur källan når under året, i °C. Tillsammans med årsmedeltemperatur och amplitud beskriver den hur källtemperaturen svänger genom säsongen, vilket påverkar verkningsgraden.',
          sourceTemperatureAmplitude:
            'Temperaturamplituden beskriver hur mycket källtemperaturen svänger över och under årsmedelvärdet under året, i °C. Större amplitud betyder större säsongsvariation i verkningsgrad. Ange den om den är känd, annars används typiska värden för källan.',
          energyWellDimensioning:
            'Vägledande värden för årsmedeltemperatur och årsamplitud för energibrunnar (borrhål). Välj den beskrivning som bäst passar brunnens användning och dimensionering, så sätts temperaturvärdena automatiskt utifrån klimatorten.',
          waterSourceDepth:
            'Vägledande värden för årsmedeltemperatur och årsamplitud för värmeuttag i sjö och sötvatten. Välj djupet för värmeuttaget, så sätts temperaturvärdena automatiskt utifrån klimatorten.',
        },
        districtHeating: {
          maxCapacity:
            'Maximal kapacitet är den högsta effekt fjärrvärme- eller fjärrkylanslutningen kan leverera till byggnaden, i kW. Ange den om den är känd från dokumentation eller anläggningsdata. Används för att bedöma om källan täcker effektbehovet.',
          efficiency:
            'Verkningsgraden beskriver hur stor del av levererad energi från fjärrvärmenätet som faktiskt blir nyttig värme i byggnaden, efter förluster i växlare och distribution. Ange ett samlat värde om du vill åsidosätta standardvärdena för centralen.',
          temperatureFromSource:
            'Temperatur från källa är framledningstemperaturen som fjärrvärme- eller fjärrkylnätet levererar in till värmeväxlaren, i °C. Ange den om den är känd. Ger en mer realistisk beskrivning av centralens drift och verkningsgrad.',
          heatExchangerLoss:
            'Värmeväxlaren överför energi från fjärrvärmenätet till byggnadens eget system, och en del energi går förlorad på vägen. Välj isoleringsnivå och utloppstemperaturområde för att beskriva förlusten mer detaljerat, eller ange tapskoefficienten direkt om ett dokumenterat värde finns. Lämna fälten tomma för att använda standardvärden.',
          distributionHeatLoss:
            'Distributionsvärmeförlust är den energi som förloras i rörnätet mellan centralen och byggnadens system. Välj tillförseltemperaturområde för distributionen för att beskriva förlusten mer detaljerat, eller ange tapskoefficienten direkt om den är känd. Lämna fälten tomma för att använda standardvärden.',
          coolingHeatExchanger:
            'Kylväxlaren överför kyla från fjärrkyla eller kylcentralen till byggnadens system, och en del energi går förlorad. Välj isoleringsnivå om kylsidan ska modelleras mer detaljerat, eller ange U-värdet direkt om det är känt. Lämna fälten tomma för att använda standardvärden.',
          co2eEmissionFactor:
            'CO₂e-utsläppsfaktorn anger hur mycket växthusgasutsläpp som följer med energin från fjärrvärme eller fjärrkyla, angivet i gram per kWh. Ange ett specifikt värde om du vill använda nätets faktiska utsläppssiffra. Den påverkar endast utsläppsredovisningen, inte själva energibehovet.',
          energyPrice:
            'Energipriset är kostnaden per kWh levererad energi från fjärrvärme eller fjärrkyla. Ange ett specifikt pris om du vill ha kostnadsberäkningar med verkliga priser, annars kan fältet lämnas tomt. Påverkar endast kostnadssiffror, inte energi eller utsläpp.',
        },
        combustionBoiler: {
          boilerType:
            'Pannans typ beskriver vilken sorts förbränningspanna anläggningen är, till exempel olja, gas eller biomassa. Välj den som bäst beskriver anläggningen. Valet styr standardförutsättningar som verkningsgrad och utsläppsnivå.',
          heatingCapacity:
            'Värmekapaciteten är pannans nominella värmeeffekt i kW, alltså hur mycket effekt den kan leverera under normala förhållanden. Detta är huvudvärdet för att bedöma om pannan täcker effektbehovet.',
          performance:
            'Prestanda anger pannans nominella verkningsgradsnivå, alltså hur effektivt bränslet omvandlas till nyttig värme. Välj eller ange nivå om detta är dokumenterat för pannan, annars används standardvärden.',
          fuelSource:
            'Bränslekällan är vad pannan förbränner, till exempel olja, gas eller biobränsle. Valet bestämmer standardenergiinnehåll och utsläppsfaktor för bränslet, och påverkar därmed både energi- och utsläppsberäkning.',
          fuelEnergyContent:
            'Energiinnehållet är hur mycket energi bränslet innehåller per enhet, till exempel kWh per liter. Ange ett specifikt värde om du vill ha mer exakta förutsättningar än standardvärdena för valt bränsle.',
          co2eEmissionFactor:
            'CO₂e-utsläppsfaktorn anger hur mycket växthusgasutsläpp förbränning av bränslet ger, angivet i gram per kWh. Ange ett specifikt värde om du vill ha en exakt utsläppsberäkning. Den påverkar endast utsläppsredovisningen, inte energibehovet.',
          efficiencyAtLowerLoad:
            'Detta är pannans värmeeffekt när den kör på cirka 30 % av full last, i kilowatt. Värdet krävs tillsammans med fullastvärdet för att simuleringen ska kunna modellera pannans beteende vid dellast.',
          effectAtFullLoad:
            'Detta är pannans värmeeffekt vid full last i kilowatt, det vill säga hur mycket effekt den levererar vid maximal drift. Värdet krävs för att simuleringen ska dimensionera pannan korrekt.',
          isCondensing:
            'En kondenserande panna utnyttjar även värmen i vattenångan i rökgasen och uppnår därmed högre verkningsgrad än en vanlig panna. Markera detta om pannan är kondenserande.',
          isCHP:
            'Ett kraftvärmeverk (CHP) producerar både el och värme samtidigt från samma bränsle, vilket ger hög total energiutnyttjande. Markera detta om anläggningen är ett CHP-verk, då visas egna CHP-inställningar.',
          scheduleStart:
            'Starttidpunkten är när pannans driftssäsong börjar, angivet som dag och månad. Fyll i detta om pannan inte går kontinuerligt eller inte följer standarddriftsprofilen, till exempel en panna som bara används under eldningssäsongen.',
          scheduleEnd:
            'Sluttidpunkten är när pannans driftssäsong avslutas, angivet som dag och månad. Fylls i tillsammans med starttidpunkten för att beskriva perioden pannan är i drift.',
          seasonalMeanTemp:
            'Säsongsmedeltemperaturen är den genomsnittliga utetemperaturen över driftssäsongen, i °C. Ange den om anläggningen ska beskrivas med mer detaljerade temperaturförutsättningar än standard.',
          temperatureSupply:
            'Framledningstemperaturen är temperaturen på vattnet pannan skickar ut till värmesystemet, i °C. Lägre framledningstemperatur ger ofta bättre verkningsgrad, särskilt för kondenserande pannor. Ange den om den är känd.',
          temperatureReturn:
            'Returtemperaturen är temperaturen på vattnet som kommer tillbaka till pannan från värmesystemet, i °C. För kondenserande pannor är låg returtemperatur viktig för att uppnå kondensering och hög verkningsgrad. Ange den om den är känd.',
        },
        electricBoiler: {
          maxCapacity:
            'Maximal kapacitet är den högsta effekt den elektriska pannan kan leverera, i kW. Detta är huvudvärdet för att bedöma om pannan täcker effektbehovet.',
          insulationGrade:
            'Isoleringsgraden beskriver hur väl själva pannan är isolerad och avgör hur mycket värme den förlorar till omgivningen medan den är på. Välj grad om du vill ha mer exakt modellering av värmeförlusten från pannan.',
          efficiency:
            'Verkningsgraden beskriver hur stor del av tillförd elektricitet som blir nyttig värme, efter förluster i pannan. Elektriska pannor har normalt hög verkningsgrad. Ange ett värde om du vill åsidosätta standardförutsättningarna.',
          co2eEmissionFactor:
            'CO₂e-utsläppsfaktorn anger hur mycket växthusgasutsläpp som följer med elen pannan använder, angivet i gram per kWh. Ange ett specifikt värde om du vill ha en exakt utsläppsberäkning. Den påverkar endast utsläppsredovisningen, inte energibehovet.',
          temperatureSupply:
            'Framledningstemperaturen är temperaturen på vattnet pannan skickar ut till värmesystemet, i °C. Den påverkar vilka värmeavgivare pannan kan betjäna och värmeförlusten i systemet. Ange den om den är känd.',
          temperatureReturn:
            'Returtemperaturen är temperaturen på vattnet som kommer tillbaka till pannan från värmesystemet, i °C. Tillsammans med framledningstemperaturen beskriver den temperaturnivån i systemet. Ange den om den är känd.',
        },
        solarThermal: {
          solarType:
            'Solfångartypen beskriver kollektorprincipen, till exempel plana solfångare eller vakuumrörsolfångare. Vakuumrör ger vanligtvis bättre prestanda vid låga utetemperaturer. Valet påverkar standardförutsättningarna för anläggningens utbyte.',
          azimuth:
            'Azimut är kollektorernas orientering mot väderstreck i grader, där 0 vanligtvis betyder rakt mot söder. Den beskriver vilket håll kollektorerna vetter och påverkar starkt hur mycket solenergi de fångar.',
          tilt: 'Lutningen är kollektorernas vinkel från horisontalplanet i grader, där 0 är platt och 90 är lodrätt. Tillsammans med azimut bestämmer den hur mycket solinstrålning kollektorerna tar emot under året.',
          adjustmentFactor:
            'Justeringsfaktorn skalar det beräknade solutbytet upp eller ner för att ta hänsyn till lokala förhållanden som skugga eller nedsmutsning. Ange ett värde endast om du vill korrigera standardberäkningen, annars kan fältet lämnas tomt.',
          performance:
            'Prestanda anger anläggningens nominella verkningsgrad eller kapacitetsnivå, alltså hur effektivt kollektorerna omvandlar solinstrålning till nyttig värme. Välj eller ange nivå om detta är känt från dokumentation, annars används standardvärden.',
          pipeLength:
            'Rörlängden är den totala längden på rören mellan kollektorerna och lagringstanken, i meter. Längre rör ger större värmeförlust. Ange den tillsammans med rörisoleringstyp om du vill beräkna rörförluster mer detaljerat.',
          pipeInsulationType:
            'Rörisoleringstypen beskriver hur väl rören mellan kollektorerna och tanken är isolerade, vilket sätter standardvärmeförlusten per meter rör. Välj den om känd, annars används ett standardvärde.',
          pipeUValue:
            'U-värdet för rören anger hur mycket värme rören i kollektorkretsen förlorar per meter och grad temperaturskillnad (W/mK). Ett lägre värde betyder bättre isolering. Ange det om det är känt, annars härleds det från vald rörisoleringstyp.',
          collectorArea:
            'Samlingsarean är solfångarnas totala aktiva area, i m². Detta är en central input för produktionsberäkningen, eftersom mer kollektorarea ger mer solenergi.',
          tankSpiralPlacementFactor:
            'Placeringsfaktorn för tankspiralen beskriver var i ackumulatortanken solvärmespiralen är placerad, vilket påverkar hur effektivt solvärmen överförs till vattnet. Ange ett värde om du har detaljdata för systemet, annars används ett standardvärde.',
          temperatureColdWater:
            'Kallvattentemperaturen är temperaturen på vattnet som tillförs systemet innan det värms upp av solfångarna, i °C. Lägre kallvattentemperatur ger högre solutbyte. Ange ett värde om du vill åsidosätta standardvärdet.',
          percentageOfCollectorLoopOutside:
            'Detta är hur stor del av kollektorkretsen (rör och komponenter) som ligger utomhus, i procent. Rör som ligger ute förlorar mer värme. Ange ett värde om detta är relevant för förlustberäkningen.',
          collectorSpecs:
            'Dessa värden utgör solfångarens verkningsgradskurva, hämtad från produktdatabladet eller Solar Keymark-certifikatet. η₀ är den optiska verkningsgraden vid ingen temperaturskillnad, medan värmeförlustkoefficienterna a₁ och a₂ beskriver hur snabbt verkningsgraden sjunker när kollektorn blir varmare än omgivningen. Ange värdena om dokumentation finns, annars används standardvärden.',
          snowCoverageMonths:
            'Välj vilka månader solfångarna normalt är snötäckta. Under dessa månader producerar kollektorerna lite eller ingen energi, så detta ger en mer realistisk årsberäkning där snö påverkar produktionen.',
          insulationFactorForCollectionLoop:
            'Isoleringsfaktorn för kollektorkretsen beskriver hur väl rör och komponenter i solvärmekretsen är isolerade totalt sett. Välj nivå om du vill ha en mer exakt beräkning av värmeförlusten i kretsen, annars används ett standardvärde.',
        },
        otherSource: {
          fuelType:
            'Bränsletypen är energibäraren denna försörjning använder, till exempel olja, gas, biobränsle, fjärrvärme eller elektricitet. Valet bestämmer standardutsläppsfaktor och hur energin förs i redovisningen.',
          maxCapacity:
            'Maximal kapacitet är den högsta effekt denna energikälla kan leverera, i kW. Detta är huvudvärdet för att bedöma om källan täcker effektbehovet.',
          efficiency:
            'Verkningsgraden beskriver hur stor del av tillförd energi som blir nyttig värme eller kyla, efter förluster i källan. Ange ett värde om det är känt, annars används en standardförutsättning.',
          co2eEmissionFactor:
            'CO₂e-utsläppsfaktorn anger hur mycket växthusgasutsläpp som följer med energin denna källa använder, angivet i gram per kWh. Ange ett specifikt värde om du vill ha en exakt utsläppsberäkning. Den påverkar endast utsläppsredovisningen, inte energibehovet.',
          energyPrice:
            'Energipriset är kostnaden per kWh energi från denna källa. Ange ett specifikt pris om du vill ha kostnadsberäkningar med verkliga priser, annars kan fältet lämnas tomt. Påverkar endast kostnadssiffror, inte energi eller utsläpp.',
        },
        accumulationTank: {
          purpose:
            'En ackumulatortank lagrar värme eller kyla så att produktion och förbrukning kan förskjutas i tid. Välj syfte, till exempel värmelager, kyllager eller varmvatten, som beskriver vilken funktion tanken har i systemet.',
          volume:
            'Volymen är tankens lagringskapacitet i liter och är huvudparametern för hur mycket värme eller kyla tanken kan lagra. Ange det om en ackumulatortank finns.',
          insulation:
            'Isoleringsnivån beskriver hur väl tanken är isolerad och avgör hur mycket värme som förloras till omgivningen. Välj nivå eller typ om känd. Används för att uppskatta eller åsidosätta värmeförlusten från tanken.',
          heatLoss:
            'Värmeförlust (W/K) anger hur mycket effekt tanken förlorar till omgivningen per grad temperaturskillnad. Ange ett dokumenterat värde om du har det. Kan normalt lämnas tomt om volym och standardisolering är tillräckliga.',
          setpoint:
            'Börvärdestemperaturen är önskad lagringstemperatur i tanken, i °C. Den styr hur varmt eller kallt mediet hålls och påverkar både förluster och kapacitet.',
          maxTemp:
            'Maximitemperaturen är den högsta temperatur tanken tillåts nå, i °C. Ange den om detta är känt eller relevant för styrningen.',
          minTemp:
            'Minimitemperaturen är den lägsta temperatur tanken tillåts falla till, i °C. Ange den om detta är känt eller relevant för styrningen.',
          minTempDhw:
            'Minimitemperaturen är den lägsta temperatur tanken tillåts falla till, i °C. För tappvarmvattentankar bör den hållas på minst 70 °C för att förhindra tillväxt av legionellabakterier.',
        },
      },
      excessEnergy: {
        medium:
          'Mediet är vad överskottsenergin strömmar i: luft, till exempel en frånluftskanal, eller vätska, till exempel ett spillvattenrör. Valet bestämmer vilka fält som visas och hur tillgänglig energi beräknas.',
        name: 'Ge överskottsenergikällan ett tydligt namn. Namnet används för att identifiera potentiella källor för återvinning, till exempel frånluft från ett kök eller spillvärme från en process.',
        ductShape:
          'Välj medium och kanalform för källan. Kanalformen, till exempel rund eller rektangulär, används tillsammans med måtten för att beräkna tvärsnittet och därmed tillgänglig energiström när överskottsenergin tas ut från luft.',
        ductWidthDiameter:
          'Ange kanalens bredd eller diameter i mm om det är känt. Används tillsammans med kanalformen, och eventuellt höjd, lufthastighet eller volymflöde, för att beräkna hur mycket luft som strömmar genom kanalen.',
        height:
          'Ange kanalhöjd i mm om kanalformen kräver det, till exempel vid en rektangulär kanal. Tillsammans med bredden ger den kanalens tvärsnitt.',
        airspeed:
          'Lufthastigheten är hur snabbt luften strömmar genom kanalen, i m/s. Ange den om volymflödet inte är känt direkt, då beräknas luftmängden utifrån hastighet och kanalens tvärsnitt.',
        exhaustTempAir:
          'Frånluftstemperaturen är temperaturen på luftströmmen som överskottsenergin hämtas från, i °C. Temperaturen är avgörande för att bedöma hur mycket energi som kan återvinnas; högre temperatur ger mer tillgänglig värme.',
        exhaustTempLiquid:
          'Ange temperaturen på vätskeströmmen som överskottsenergin hämtas från, i °C. Temperaturen är avgörande för att bedöma hur mycket energi som kan återvinnas från vätskan.',
        volumeFlowAir:
          'Volymflödet är hur mycket luft som passerar per timme, i m³/h. Tillsammans med temperaturen bestämmer det hur mycket energi som är tillgänglig för återvinning. Ange det om det är känt, annars kan det beräknas från kanalgeometri och lufthastighet.',
        volumeFlowLiquid:
          'Volymflödet är hur mycket vätska som passerar per timme, i L/h. Tillsammans med temperaturen bestämmer det hur mycket energi som är tillgänglig för återvinning. Ange det om det är känt.',
      },
      solarPv: {
        panelAngle:
          'Lutningen på solpanelerna mätt från horisontalplanet, i grader. En panel som ligger platt på taket är 0° och en panel som står lodrätt är 90°. Lutningen avgör hur direkt solljuset träffar panelerna under året och påverkar därför den beräknade årsproduktionen kraftigt.',
        name: 'Ett tydligt och igenkännbart namn på denna solcellsanläggning. Namnet används för att identifiera anläggningen i listor, resultat och rapporter, vilket är till hjälp när en byggnad har flera separata solcellsanläggningar.',
        panelArea:
          'Den aktiva ytan på solpanelerna, i kvadratmeter. Ange antingen ytan för en enskild panel eller den sammanlagda ytan för hela anläggningen, beroende på hur anläggningen registreras, och låt Antal stämma med det valet. Tillsammans med verkningsgraden är ytan en av de centrala indata som avgör hur mycket el anläggningen kan producera.',
        quantity:
          'Antalet solpaneler i anläggningen om det är känt. Det kombineras med panelytan och verkningsgraden för att beräkna installerad kapacitet och måste stämma med hur ytan angetts: använd antalet paneler när Panelyta är per panel och 1 när Panelyta är den sammanlagda ytan.',
        yearInstalled:
          'Året då solcellsanläggningen togs i drift. Det registreras för besiktningen, men beräkningen använder det inte: panelernas åldrande beräknas alltid över en fast livslängd på 30 år, med degraderingsförlusten per år.',
        soilingLocation:
          'Platstypen som avgör hur snabbt damm, pollen och föroreningar byggs upp på panelerna. När du väljer en plats, till exempel stadsnära, lantlig eller annan exponering, läses en standardiserad månadsprofil för nedsmutsning in för den miljön, som du sedan kan finjustera per månad nedan.',
        monthlySoiling:
          'Nedsmutsning är produktionsförlusten som orsakas av smuts, damm, snö och föroreningar på panelytan, och den varierar under året. När du väljer en plats fylls en förenklad standardprofil i; ange ditt eget värde för varje månad här om du vill åsidosätta profilen med platsspecifika siffror.',
        cellType:
          'Solcellstekniken i panelerna, till exempel monokristallint eller polykristallint kisel. Celltypen avgör hur effektivt panelerna omvandlar solljus till el, så valet sätter en representativ standardverkningsgrad som du fortfarande kan justera.',
        nominalEfficiency:
          'Andelen av inkommande solenergi som panelerna omvandlar till el under standardtestförhållanden, angiven som ett decimaltal (till exempel 0,20 för 20 %). Ange det dokumenterade värdet från databladet om det är känt; annars används standardvärdet från vald celltyp.',
        panelAzimuth:
          'Väderstrecket som panelerna är riktade mot, i grader från 0 till 360 (söder ligger runt 180° på norra halvklotet). Azimut avgör, tillsammans med lutningen, hur mycket av solens bana panelerna fångar upp under dagen och året, och påverkar därför den beräknade produktionen direkt.',
        shadingFactor:
          'Andelen solljus som panelerna förlorar på grund av skuggning från grannbyggnader, terräng eller vegetation, från 0 till 1. 0 betyder ingen skuggning och 1 betyder helt skuggat, så standardvärdet 0,05 är en förlust på 5 %. Värdet registreras men används inte ännu i beräkningen.',
        mountingType:
          'Hur panelerna är monterade, till exempel takintegrerade eller fristående med en luftspalt. Monteringstypen styr hur väl panelerna kyls av omgivande luft, vilket ingår i den mer detaljerade modellen för paneltemperatur och förluster. Välj den om du vill ha den detaljnivån.',
        windExposure:
          'Hur exponerad anläggningen är för vind. Vind kyler panelerna och sänker driftstemperaturen, vilket förbättrar verkningsgraden, så detta används tillsammans med monteringstypen i den mer detaljerade modellen för paneltemperatur. Välj den om den är känd.',
        heatLossFactor:
          'Hur lätt panelerna avger värme till omgivningen, i W/m²K. Den härleds normalt från monteringstyp och vindexponering, men du kan ange ett värde här för att åsidosätta dessa standardantaganden och styra hur paneltemperaturen modelleras.',
        inverterEfficiency:
          'Andelen av likströmmen från panelerna som växelriktaren levererar som användbar växelström, som ett decimaltal (till exempel 0,945). Den fångar omvandlingsförlusten i växelriktaren; ange det dokumenterade värdet från databladet om det är känt.',
        degradationLoss:
          'Den gradvisa och permanenta minskningen av panelproduktionen när modulerna åldras, som ett decimaltal (till exempel 0,005 för 0,5 % per år). Ange det om du vill modellera den minskade prestandan över anläggningens livslängd mer exakt.',
        inverterLoss:
          'Ytterligare förluster kopplade till växelriktaren och dess drift, som ett decimaltal. Använd detta när du vill registrera växelriktarförluster separat från växelriktarens verkningsgrad i stället för att slå ihop dem till en enda siffra.',
        transmissionProduct:
          'En samlad faktor (0 till 1) för de optiska förlusterna när ljuset passerar genom panelens täckglas och når cellerna, som reflektion och absorption. Ange den som ett decimaltal när vald beräkningsmetod använder denna term.',
        temperatureCoefficient:
          'Hur mycket panelproduktionen ändras med temperaturen, i %/°C. Den är normalt negativ eftersom produktionen sjunker när panelerna värms upp över temperaturen de är mätta vid. Ange det dokumenterade värdet från databladet om ett sådant finns för panelerna.',
        incidentAngleModifier:
          'En faktor (0 till 1) som tar hänsyn till de extra reflektionsförlusterna när solljuset träffar panelen snett i stället för rakt på. Ange den som ett decimaltal om du vill använda den mer detaljerade solmodellen som fångar dessa infallsvinkeleffekter.',
      },
      battery: {
        name: 'Ett tydligt och igenkännbart namn på detta batteri. Namnet används för att identifiera batteriet i listor, resultat och rapporter, vilket är användbart när en byggnad har flera batterier.',
        maxCapacity:
          'Den totala mängden energi batteriet kan lagra, i kWh. Detta är batterisystemets angivna kapacitet och sätter gränsen för hur mycket solöverskott som kan lagras för senare användning.',
        maxChargePower:
          'Den högsta effekt batteriet kan laddas med, i kW. Den begränsar hur snabbt batteriet kan ta emot solöverskott eller el från nätet.',
        maxDischargePower:
          'Den högsta effekt batteriet kan leverera tillbaka till byggnaden, i kW. Den begränsar hur stor del av byggnadens last batteriet kan täcka i varje ögonblick.',
        chargeEfficiency:
          'Hur stor andel av energin som skickas in i batteriet som faktiskt lagras, mellan 0 och 1. Låt värdet stå på 0 för att använda ett typiskt standardvärde för litiumjonbatterier.',
        dischargeEfficiency:
          'Hur stor andel av den lagrade energin som faktiskt levereras när batteriet laddas ur, mellan 0 och 1. Låt värdet stå på 0 för att använda ett typiskt standardvärde för litiumjonbatterier.',
        minStateOfCharge:
          'Den lägsta nivå batteriet får laddas ur till, som andel av full kapacitet mellan 0 och 1. En reserv skyddar batteriets livslängd. Låt värdet stå på 0 för att använda standardvärdet.',
        maxStateOfCharge:
          'Den högsta nivå batteriet får laddas upp till, som andel av full kapacitet mellan 0 och 1. Att ladda något under fullt skyddar batteriets livslängd. Låt värdet stå på 0 för att använda standardvärdet.',
        peakShavingThreshold:
          'Det nätuttag batteriet försöker hålla byggnaden under, i kW. När byggnaden annars skulle ta mer än detta från nätet laddas batteriet ur för att täcka skillnaden. Låt värdet stå på 0 för att stänga av kapning av effekttoppar; batteriet lagrar då bara solöverskott och täcker underskott.',
        preChargeStateOfCharge:
          'Den nivå batteriet förladdas till från nätet under lugna timmar, som andel av full kapacitet mellan 0 och 1, så att det är redo för nästa effekttopp. Används bara när en gräns för effekttoppar är satt. Låt värdet stå på 0 för att stänga av förladdning.',
      },
    },
  },

  // Page titles
  title: 'Bygginspektioner',
  sidebarTitle: 'Inspektion',
  new: 'Ny bygginspektion',
  edit: 'Redigera inspektion',

  // List page
  fetchError: 'Misslyckades att hämta bygginspektioner.',
  noInspections: 'Inga bygginspektioner hittades.',
  createNew: 'Ny inspektion',
  confirmDeleteTitle: 'Radera inspektioner',
  confirmDeleteDescription:
    'Är du säker på att du vill radera denna inspektion?',
  duplicate: 'Duplicera',
  duplicating: 'Duplicerar inspektion...',
  duplicateSuccess: 'Inspektion duplicerad',
  duplicateError: 'Kunde inte duplicera inspektion',
  renameInspection: 'Byt namn på inspektion',

  // Common
  common: {
    // generic
    custom: 'Anpassad',
    standard: 'Standard',
    other: 'Annat',
    text: 'Text',
    from: 'Från',
    to: 'Till',
    hide: 'Dölj',
    show: 'Visa',
    horizontal: 'Horisontell',
    vertical: 'Vertikal',
    addImage: 'Lägg till bild',
    confirmDeleteImage: 'Är du säker på att du vill ta bort den här bilden?',
    generating: 'Genererar...',
    indoorClimate: 'Inomhusklimat',
    score: 'Poäng',
    energyData: 'Energidata',
    air: 'Luft',
    liquid: 'Vätska',
    round: 'Rund',
    square: 'Fyrkantig/rektangulär',

    // field labels
    quantity: 'Antal',
    location: 'Plats',
    priority: 'Prioritet',
    yearInstalled: 'Installationsår',
    medium: 'Medium',

    // section / navigation labels
    inspection: 'Inspektion',
    info: 'Information',
    purpose: 'Syfte',
    module: 'Modul',
    control: 'Styrning & Reglering',
    equipment: 'Utrustning',
    hvacSystems: 'VVS-system',
    thermalZones: 'Termiska zoner',
    zones: 'Zoner',
    heatingCooling: 'Uppvärmning & kylning',
    heatingAndCooling: 'Uppvärmning och kylning',
    heatingOnly: 'Endast värme',
    domesticHotWater: 'Tappvatten',
    centralEnergy: 'Central energi',
    excessEnergy: 'Överskottsenergi',
    solarPv: 'Solceller',
    solarThermal: 'Solvärme',
    solarCells: 'Solceller',
    attachments: 'Bilagor',
    annualSimulation: 'Årssimulering',
    energyLabel: 'Energimärkning',
    actions: 'Åtgärder',
    lighting: 'Belysning',
    report: 'Rapport',
    hvac: 'VVS',
    windows: 'Fönster',
    doors: 'Dörrar',
    gates: 'Portar',
    walls: 'Väggar',
    exteriorWalls: 'Ytterväggar',
    floor: 'Golv mot mark',
    roof: 'Yttertak',
    basement: 'Källarkonstruktion',
    groundConditions: 'Markförhållanden',
    airLeakage: 'Luftläckage',
    thermalMass: 'Termisk massa',
    internalLoads: 'Interna laster',
    productionEquipment: 'Produktionsutrustning',
    ground: 'Mark',
    zone: 'Zon',
    wall: 'Vägg',
    window: 'Fönster',
    door: 'Dörr',
    gate: 'Port',

    // climate
    climate: 'Klimat',
    climatized: 'Klimatiserad',
    partlyClimatized: 'Delvis klimatiserad',
    unclimatized: 'Oklimatiserad',
    floorHeight: 'Våningshöjd (m)',

    // units and physical quantities
    area: 'Area (m²)',
    areaShort: 'Area',
    volume: 'Volym (L)',
    volumeShort: 'Volym',
    length: 'Längd (m)',
    power: 'Effekt (kW)',
    powerShort: 'Effekt',
    uValue: 'U-värde (W/m²K)',
    uValueShort: 'U-värde',
    coverageArea: 'Täckningsarea (m²)',
    coverageAreaShort: 'Täckningsarea',
    coverageVolume: 'Täckningsvolym',
    heatingEffect: 'Värmeeffekt (kW)',
    coolingEffect: 'Kyleffekt (kW)',
    effect: 'Effekt (kW)',
    cop: 'COP',
    eer: 'EER',
    seasonalCOP: 'Säsongs-COP',
    seasonalEER: 'Säsongs-EER',
    efficiency: 'Verkningsgrad',
    systemEfficiency: 'Systemverkningsgrad (%)',
    co2eEmissionFactor: 'CO₂e-utsläppsfaktor (g/kWh)',
    temperatureSupply: 'Framledningstemperatur (°C)',
    temperatureReturn: 'Returtemperatur (°C)',
    avgTemp: 'Snitttemp',
    sfp: 'SFP',
    bra: 'BRA',
    airVolume: 'Luftflöde',
    heatRecovery: 'Värmeåtervinning',
    panelArea: 'Panelarea',
    cellType: 'Celltyp',
    azimuth: 'Azimut',
    value: 'Värde',
    unit: 'Enhet',

    // system / fuel
    systemType: 'Systemtyp',
    systemTypeShort: 'Systemtyp',
    energySource: 'Energikälla',
    energySourceShort: 'Energikälla',
    specificFuelType: 'Bränsletyp',
    selectSpecificFuelType: 'Välj bränsle...',
    inverterControlled: 'Invertorstyrd',
    nominalLoad: 'Nominell last',
    minimumLoad: 'Minimumlast',
    degradeCoeff: 'Degraderingskoeff',
    heatPump: 'Värmepump',
    electric: 'Elektrisk',
    oil: 'Olja',
    gas: 'Gas',
    rock: 'Berg',
    coolingOnly: 'Endast kylning',

    // performance / magnitude grades
    high: 'Hög',
    low: 'Låg',
    normal: 'Normal',

    // dimensions
    width: 'Bredd (m)',
    height: 'Höjd (m)',
    depth: 'Djup (m)',

    // zone editor
    userDefined: 'Användardefinierad',
    calculator: 'Kalkylator',
    compass: {
      N: 'N',
      NE: 'NO',
      E: 'O',
      SE: 'SO',
      S: 'S',
      SW: 'SV',
      W: 'V',
      NW: 'NV',
    },
    directions: {
      n: 'Norr (0°)',
      ne: 'Nordost (45°)',
      e: 'Öst (90°)',
      se: 'Sydost (135°)',
      s: 'Syd (180°)',
      sw: 'Sydväst (225°)',
      w: 'Väst (270°)',
      nw: 'Nordväst (315°)',
    },
    structuralNodes: 'Strukturella noder',
    structuralNode: 'Strukturell nod',
    addStructuralNode: 'Lägg till strukturell nod',
    copyStructuralNode: 'Kopiera strukturell nod',
    confirmDeleteStructuralNode: 'Ta bort denna strukturella nod?',
    boundary: 'Gräns',
    boundaryInteriorAir: 'Innerluft',
    boundaryExterior: 'Yttervägg',
    boundaryAdjacentZone: 'Angränsande zon',
    boundaryAdiabatic: 'Adiabatisk',
    node: 'Nod',
    addNode: 'Lägg till nod',
    copyNode: 'Kopiera nod',
    confirmDeleteNode: 'Ta bort denna nod?',
    surfaceType: 'Yttyp',
    surfaceCeiling: 'Tak (innertak)',
    surfaceArea: 'Yta (m\u00B2)',
    heatTransferCoeff: 'Värmeövergångskoeff. (W/m\u00B2K)',
    totalMass: 'Total massa (kg/m\u00B3)',
    specificHeatCapacity: 'Specifik värmekapacitet (J/kgK)',

    // insulation grades
    insulated: 'Isolerad',
    uninsulated: 'Oisolerad',
    poorlyInsulated: 'Dåligt isolerad',
    normallyInsulated: 'Normalt isolerad',
    wellInsulated: 'Välisolerad',
    veryWellInsulated: 'Mycket välisolerad',
    selectInsulation: 'Välj isolering...',
    selectPerformance: 'Välj verkningsgrad...',
    selectFuelType: 'Välj bränsletyp...',

    // UI layout
    basicSettings: 'Grundinställningar',
    additionalInfo: 'Ytterligare information',
    showAdvanced: 'Visa avancerat',
    hideAdvanced: 'Dölj avancerat',
    advanced: 'Avancerat',

    // actions
    settingUp: 'Konfigurerar...',
    co2PerKwh: 'CO₂ per kWh [g]',
    gridFee: 'Nätavgift [NOK/kWh]',
    enovaSupport: 'Enova-stöd [%]',
    descriptionPlaceholder:
      'Beskriv åtgärden i detalj: vad som ändras, varför och förväntat resultat. Inkludera en beräkning av antagen minskad energianvändning om åtgärden genomförs, samt en bedömning av kostnader och konsekvenser avseende fukt och inomhusklimat kopplade till åtgärden.',
    electricityZone: 'Elområde',
    selectZone: 'Välj ett område...',
    runSimulation: 'Kör byggsimulering',
    runningSimulation: 'Kör simulering...',
    simulationDescription: 'Kör timbaserad energibalanssimulering',
    baselineProgress: 'Kör referenssimulering... (1/2)',
    actionProgress: 'Kör åtgärdssimulering... (2/2)',
    baselineStarted: 'Bassimulering startad...',
    simulationStarted: 'Åtgärdssimulering startad...',
    noAnnualSimulation:
      'Kör en årlig simulering först för att aktivera åtgärdsjämförelse.',
    simulationResults: 'Simuleringsresultat',
    lastSimulated: 'Senast simulerad',
    nettEnergyDemand: 'Netto energibehov',
    energyCategory: 'Energikategori',
    baselineKwh: 'Referens (kWh)',
    actionKwh: 'Åtgärd (kWh)',
    savingsKwh: 'Besparing (kWh)',
    baselineKwhM2: 'Referens (kWh/m²)',
    actionKwhM2: 'Åtgärd (kWh/m²)',
    savingsPercent: 'Besparing (%)',
    baseline: 'Referens',
    afterAction: 'Efter åtgärd',
    solarProduction: 'Solproduktion',
    savings: 'Besparing',
    costSavings: 'Kostnad och besparing',
    annualEnergySavings: 'Årlig energibesparing',
    kwhYear: 'kWh/år',
    energySavingsTooltip: 'Minskning av totalt energibehov från förbättringar',
    reduction: 'minskning',
    increase: 'ökning',
    annualCostSavings: 'Årlig kostnadsbesparing',
    nokYear: 'NOK/år',
    costSavingsTooltip:
      'Total kostnadsbesparing från minskad energiförbrukning och intäkter från exporterad solproduktion',
    netCo2Reduction: 'Netto CO₂-minskning',
    kgCo2Year: 'kg CO₂/år',
    co2Tooltip: 'Använder {value} g CO₂/kWh',
    tonnes: 'ton',
    paybackPeriod: 'Återbetalningstid',
    paybackTooltip: 'Tid att återhämta den initiala investeringen',
    years: 'år',
    investmentLabel: 'Investering: {value} NOK',
    noInvestmentCost: 'Ingen investeringskostnad angiven',
    beforeExisting: 'Före - Befintligt system',
    afterNew: 'Efter - Nytt system',
    investment: 'Investering',
    installationType: 'Installationstyp',
    simple: 'Enkel',
    complex: 'Komplex',
    deliveredEnergy: 'Levererad energi',
    roiTitle: 'Avkastning över tid',
    roiCumulativeSavings: 'Kumulativ besparing',
    roiNetValue: 'Nettovärde (efter investering)',
    roiYears: 'År',
    roiBreakEven: 'Nollpunkten nås när nettovärdet passerar noll (år {value})',

    // misc
    presenceControl: 'Närvarokontroll',
    distributionLosses: 'Distributions- och ackumuleringsförluster',
    installationCost: 'Installationskostnad [NOK]',
    installationCostShort: 'Installationskostnad',
    noZones:
      'Inga termiska zoner hittades. Lägg till termiska zoner i sektionen för termiska zoner först.',

    // shared energy source labels
    energySources: {
      electricity: 'Elektricitet',
      heatpumpAirToAir: 'Värmepump luft-till-luft',
      fossilOil: 'Fossil olja',
      fossilGas: 'Fossil gas',
      fossilSolidFuel: 'Fossilt fast bränsle',
      bioOil: 'Bioolja',
      bioGas: 'Biogas',
      bioSolidFuel: 'Bio fast bränsle',
      districtHeating: 'Fjärrvärme',
      districtCooling: 'Fjärrkyla',
      otherSources: 'Andra källor',
    },

    // shared schedule block
    schedule: {
      operationalSchedule: 'Driftschema',
      addSchedule: 'Lägg till schema',
      clickToToggle: 'Klicka på timmar för att växla på/av',
      avgTemp: 'Snitttemp',
      days: ['Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör', 'Sön'],
      months: [
        'Januari',
        'Februari',
        'Mars',
        'April',
        'Maj',
        'Juni',
        'Juli',
        'Augusti',
        'September',
        'Oktober',
        'November',
        'December',
      ],
      hours: 'Timmar',
      weekly: 'Veckovis',
      annual: 'Årligen',
      on: 'PÅ',
      off: 'AV',
      hoursPerDayUnit: 'h/dag',
      hoursPerWeekUnit: 'h/vecka',
      hoursPerYearUnit: 'h/år',
      setpointPerHour: 'Börvärdestemperatur per timme',
      setpointInfoTooltip:
        'Använd PÅ/AV för att styra drifttimmar. Börvärden för PÅ-timmar används i beräkningar. AV-timmar är utanför drift.',
      copyToWeekdays: 'Kopiera till vardagar',
      copyToWeekends: 'Kopiera till helg',
      resetToStandards: 'Återställ till',
      confirmDeleteSchedule: 'Ta bort detta schema?',
      fromMonth: 'Från',
      toMonth: 'Till',
    },
  },

  // List page labels
  lists: {
    quantity: 'Antal',
    totalArea: 'Totalt (m²)',
    thermalZones: {
      duplicateZone: 'Duplicera zon',
      copySuffix: 'kopia',
      duplicateSuccess: 'Zon duplicerad',
      duplicateError: 'Kunde inte duplicera zon',
    },
    exteriorWalls: {
      addFirst: 'Klicka för att lägga till din första yttervägg',
      addWall: 'Lägg till vägg',
      duplicateWall: 'Duplicera vägg',
    },
    windows: {
      addFirst: 'Klicka för att lägga till ditt första fönster',
      addWindow: 'Lägg till fönster',
    },
    doors: {
      addFirst: 'Klicka för att lägga till din första dörr',
      addDoor: 'Lägg till dörr',
    },
    gates: {
      addFirst: 'Klicka för att lägga till din första port',
      addGate: 'Lägg till port',
    },
    productionEquipment: {
      addFirst: 'Klicka för att lägga till din första produktionsutrustning',
      addEquipment: 'Lägg till produktionsutrustning',
    },
    hvac: {
      addFirst: 'Klicka för att lägga till din första VVS-enhet',
      addHvac: 'Lägg till VVS',
    },
    heatingCooling: {
      addFirstHeating: 'Klicka för att lägga till ett värme- eller kylsystem',
      addHeating: 'Lägg till system',
    },
    domesticHotWater: {
      add: 'Lägg till tappvatten',
      addFirst: 'Klicka för att lägga till tappvatten',
    },
    centralEnergy: {
      add: 'Lägg till central energimodul',
      addFirst: 'Klicka för att lägga till en central energimodul',
    },
    excessEnergy: {
      add: 'Lägg till överskottsenergimodul',
      addFirst: 'Klicka för att lägga till en överskottsenergimodul',
    },
    solarPv: {
      add: 'Lägg till solcellsmodul',
      addFirst: 'Klicka för att lägga till en solcellsmodul',
    },
    batteries: {
      add: 'Lägg till batteri',
      addFirst: 'Klicka för att lägga till ett batteri',
    },
    attachments: {
      noInspectionFound: 'Ingen inspektion hittades',
    },
  },

  // Edit page - Form fields
  inspector: 'Inspektör',
  selectBuilding: 'Välj byggnad',
  selectedBuilding: 'Byggnad',
  selectBuildingPlaceholder: 'Välj byggnad...',
  notes: 'Anteckningar',

  // Edit page - Map panel
  advancedComingSoon: 'Under utveckling',
  mapPlaceholder: 'Sastech Karta',

  // Status options
  statusDraft: 'Utkast',
  statusInReview: 'Under granskning',
  statusCompleted: 'Slutförd',

  // Validation & feedback
  buildingRequired: 'Vänligen välj en byggnad',
  gpsRequired: 'Den valda byggnaden måste ha en GPS-position',
  createSuccess: 'Inspektion skapad',
  updateSuccess: 'Inspektion uppdaterad',
  saved: 'sparad',
  saveError: 'Misslyckades att spara inspektion',
  loadError: 'Misslyckades att ladda inspektionsdata',

  // Delete dialog
  deleteTitle: 'Ta bort inspektion',
  deleteConfirm: 'Är du säker på att du vill ta bort denna inspektion?',
  deleteSuccess: 'Inspektion borttagen',
  deleteError: 'Misslyckades att ta bort inspektion',

  // Zone edit
  zoneName: 'Zonnamn',
  zoneCategory: 'Zonkategori',
  buildingSubcategory: 'Byggnadsunderkategori',
  zoneSaved: 'Zon sparad',
  standardElementsUpdated: 'Uppdaterade {count} element till {tek}',
  braRequired: 'BRA över 0 krävs',
  basementAreaRequired: 'Golvarea för källare större än 0 krävs',
  categoryRequired: 'Vänligen välj en byggnadskategori',
  yearRequired: 'Vänligen ange byggår',
  floorsRequired: 'Vänligen ange antal våningar',
  zoneCategoryRequired: 'Vänligen välj en zonkategori',
  subcategoryRequired: 'Vänligen välj en byggnadsunderkategori',
  zoneClimateRequired: 'Vänligen välj ett zonklimat',
  floorHeightRequired: 'Våningshöjd större än 0 krävs',
  airLeakageN50Required: 'Läckagetal (n50) större än 0 krävs',
  thermalBridgePsiRequired: 'Normaliserat köldbryggevärde krävs',
  panelAreaRequired: 'Panelyta större än 0 krävs',
  yearInstalledRequired: 'Installationsår krävs',
  soilingLocationRequired: 'Vänligen välj en plats för nedsmutsning',
  cellTypeRequired: 'Vänligen välj en celltyp',
  deleteZone: 'Ta bort zon',
  deleteZoneWarning: 'Denna åtgärd kan inte ångras',
  confirmDeleteZone: 'Ta bort denna zon?',
  indoorTemp: 'Starttemperatur (°C)',
  zoneClimate: 'Zonklimat',
  thermalBridgeCoeff: 'Bärande konstruktion (köldbrygga)',
  thermalBridgePsiValue: 'Normaliserat köldbryggevärde ψ (W/(m²·K))',
  thermalBridgeCoeffTypes: {
    custom: 'Anpassad',
    wood: 'Byggnad med bärande stomme i trä',
    concrete_10cm:
      'Byggnad med bärande stomme i betong, murverk eller stål och 10 cm köldbryggebrytare i fasaderna',
    concrete_5cm:
      'Byggnad med bärande stomme i betong, murverk eller stål och 5 cm köldbryggebrytare i fasaderna',
  },
  addZone: 'Lägg till zon',
  addFirstZone: 'Klicka för att lägga till din första zon',
  image: 'Bild',
  upload: 'Ladda upp',

  // Heating/Cooling edit pages
  heatingCooling: {
    deleteModule: 'Ta bort modul',
    confirmDeleteModule: 'Ta bort denna modul?',
    deleteHeating: 'Ta bort värmemodul',
    deleteCooling: 'Ta bort kylmodul',
    confirmDeleteHeating: 'Ta bort denna värmemodul?',
    confirmDeleteCooling: 'Ta bort denna kylmodul?',
    systemType: 'Typ',
    priorityHelp: '1 = högsta prioritet (täcker behov först)',
    maxTemperatureSupplied: 'Max framledningstemperatur (°C)',
    systemTypeRequired: 'Vänligen välj en systemtyp',
    energySourceRequired: 'Vänligen välj en energikälla',
    heatingEffectRequired: 'Värmeeffekt större än 0 krävs',
    coolingEffectRequired: 'Kyleffekt större än 0 krävs',
    systemEfficiencyRequired: 'Systemverkningsgrad större än 0 krävs',
    copRequired: 'COP större än 0 krävs',
    eerRequired: 'EER större än 0 krävs',
  },

  domesticHotWater: {
    deleteDhw: 'Ta bort tappvatten',
    confirmDelete: 'Ta bort denna tappvattenmodul?',
    heaterType: 'Värmartyp',
    volume: 'Volym (L)',
    setpointTemperature: 'Börvärdestemperatur (°C)',
    heatingElementPower: 'Värmeelementeffekt (kW)',
    heaterTypes: {
      electric: 'Elektrisk',
      centralHeating: 'Centralvärme',
    },
    typeSection: 'Typ',
    consumptionSection: 'Förbrukning',
    distributionSection: 'Distributionssystem',
    greyWaterSection: 'Gråvatten värmeåtervinning',
    tapFrequency: 'Tappningsfrekvens',
    tapCyclesPerDay: 'Tappningscykler per dag',
    hasCirculation: 'Varmvattensystem med cirkulation',
    pipeSpecificLength: 'Specifik varmvattenrörlängd',
    circulationPipeLength: 'Specifik cirkulationsrörlängd',
    greyWaterRecoveryType: 'Återvinningsenhetens typ',
    greyWaterEfficiencyGrade: 'Momentan verkningsgrad',
    greyWaterShareType: 'Andel varmvatten till återvinning',
    greyWaterConnectionType: 'Anslutningsvariant',
    greyWaterPatternType: 'Tappmönster',
    greyWaterHelperText:
      'Återvunnen energi från gråvatten dras av från det totala energibehovet för uppvärmning av tappvatten.',
    tapFrequencyTypes: {
      high: 'Hög tappningsfrekvens',
      normal: 'Normal tappningsfrekvens',
      low: 'Låg tappningsfrekvens',
      perDay: '/dag',
    },
    dhwPipeLengthTypes: {
      residentialLong: 'Bostad, långa rördragningar',
      residentialNormal: 'Bostad, normala rördragningar',
      residentialShort: 'Bostad, korta rördragningar',
      commercialLong: 'Kommersiell, långa rördragningar',
      commercialNormal: 'Kommersiell, normala rördragningar',
      commercialShort: 'Kommersiell, korta rördragningar',
    },
    circulationPipeLengthTypes: {
      circulationLong: 'Cirkulationssystem, långa rördragningar',
      circulationNormal: 'Cirkulationssystem, normala rördragningar',
      circulationShort: 'Cirkulationssystem, korta rördragningar',
    },
    greyWaterRecoveryTypes: {
      verticalPipe: 'Vertikal rörvärmeväxlare',
      horizontalPipe: 'Horisontell värmeväxlare',
      tankRecovery: 'Tankbaserad värmeåtervinning',
    },
    greyWaterEfficiencyGrades: {
      low: 'Låg verkningsgrad',
      normal: 'Normal verkningsgrad',
      high: 'Hög verkningsgrad',
    },
    greyWaterShareTypes: {
      allShowers: 'Alla duschar till återvinning',
      halfShowers: '50 % av duschar till återvinning',
      thirdShowers: '30 % av duschar till återvinning',
    },
    greyWaterConnectionTypes: {
      hotWaterTankOnly: 'Ansluten till varmvattentank',
      coldWaterShowerOnly: 'Ansluten till kallvattenduschkrets',
      hotWaterTankAndColdWaterShower:
        'Ansluten till varmvattentank och kallvattenduschkrets',
    },
    greyWaterPatternTypes: {
      residentialWithAccumulation: 'Bostad med gråvattenackumulering',
      residentialWithoutAccumulation: 'Bostad utan gråvattenackumulering',
      showerWithoutAccumulation: 'Duschanläggning utan gråvattenackumulering',
      showerWithAccumulation: 'Duschanläggning med gråvattenackumulering',
    },
  },

  // Pipe Link configuration
  pipeLink: {
    localEnergySources: 'Lokala energikällor',
    centralEnergySources: 'Centrala energikällor',
    noCentralModules: 'Inga centrala energimoduler konfigurerade',
    pipeConfiguration: 'Rörkonfiguration',
    spp: 'SPP (kW/(l/s))',
    constantFlow: 'Konstant flöde',
    variableFlow: 'Variabelt flöde',
    lengthOfPipe: 'Rörlängd (m)',
    percentageInHeatedSpace: '% i uppvärmt utrymme',
    avgTempOutsideHeatedSpace: 'Medeltemp. utanför uppvärmt utrymme (°C)',
    // Dropdown labels
    waterSystemQuality: 'Vattensystemkvalitet',
    waterDistributionType: 'Vattendistributionstyp',
    pipeInsulationType: 'Rörisolering',
    qualityOptions: {
      poor: 'Dålig vattendistribution',
      normal: 'Normal vattendistribution',
      good: 'Bra vattendistribution',
    },
    distributionTypes: {
      radiatorFloorHeating: 'Värmesystem, radiator/golvvärme',
      heatingBattery: 'Värmesystem, värmebatteri i ventilation',
      localCoolingCeilingBaffles: 'Kylsystem, lokal kyla/takbafflar',
      centralCoolingBattery: 'Kylsystem, centralt kylbatteri i ventilation',
      dhwCirculation: 'VVC-cirkulation',
      energyWellBrine: 'Energibrunn, brine',
    },
    insulationTypes: {
      uninsulated: 'Oisolerade rör',
      poorlyInsulated: 'Dåligt isolerade rör',
      normallyInsulated: 'Normalt isolerade rör',
      wellInsulated: 'Välisolerade rör',
      veryWellInsulated: 'Mycket välisolerade rör',
    },
    distributionPipeLengthType: 'Rörlängd per BRA',
    distributionPipeLengthTypes: {
      localAndCentralLong:
        'Både lokal och central uppvärmning, långa rördragningar',
      localAndCentralNormal:
        'Både lokal och central uppvärmning, normalt långa rördragningar',
      centralOnlyLong: 'Endast central uppvärmning, långa rördragningar',
      centralOnlyShort: 'Endast central uppvärmning, korta rördragningar',
    },
    temperatureCannotBeZero: 'Temperatur kan inte vara 0',
    pipeTemperatureZeroWarning:
      'Tillopps och/eller returtemperatur är satt till 0.',
  },

  // Production Equipment edit page
  productionEquipment: {
    deleteEquipment: 'Ta bort produktionsutrustning',
    confirmDelete: 'Ta bort denna produktionsutrustning?',
    eligibleForHarvesting: 'Kvalificerad för energiåtervinning',
    eligibleForHarvestingHelp:
      'Markera denna utrustning som kvalificerad för överskottsenergiåtervinning',
  },

  // Central Energy Module
  centralEnergy: {
    mode: 'Läge',
    heatPumpTypeRequired: 'Varje värmepump behöver en värmepumpstyp',
    heatPumpNominalLoadRequired:
      'Varje värmepump behöver en nominell last större än 0',
    heatPumpMinimumLoadRequired:
      'Varje värmepump behöver en minimibelastning större än 0',
    combustionBoilerTypeRequired: 'Varje förbränningspanna behöver en panntyp',
    combustionBoilerFuelSourceRequired:
      'Varje förbränningspanna behöver en bränslekälla',
    fillRequiredFields: 'Fyll i alla obligatoriska fält',
    requiredFieldsNotSaved:
      'Ändringar sparas inte förrän alla obligatoriska fält är ifyllda',
    solarThermalSolarTypeRequired:
      'Varje solfångarkälla behöver en solfångartyp',
    solarThermalCollectorAreaRequired:
      'Varje solfångarkälla behöver en kollektoryta större än 0',
    otherSourceMaxCapacityRequired:
      'Varje övrig källa behöver en maxkapacitet större än 0',
    otherSourceEfficiencyRequired:
      'Varje övrig källa behöver en verkningsgrad större än 0',
    heatingAndHotWater: 'Värme och varmvatten',
    thermalZone: 'Termisk zon',
    thermalZoneHelp: 'Länka till termisk zon för omgivningstemperatur',
    noZone: 'Ingen (fristående)',
    selectZone: 'Välj zon...',
    ambientTemperature: 'Omgivningstemperatur',
    ambientTempHelp:
      'Temperatur runt modulen när den inte är länkad till en zon',
    moduleName: 'Central energimodul',
    deleteModule: 'Ta bort central energimodul',
    confirmDelete: 'Ta bort denna centrala energimodul och alla energikällor?',
    notLinkedWarning:
      'Denna modul är inte kopplad till någon utrustning. Lägg till den som energikälla i uppvärmning/kylning, ventilation, varmvatten eller produktionsutrustning.',
    notLinkedListWarning:
      '{name} är inte kopplad till någon utrustning. Lägg till den som energikälla för att använda den.',
    notesAttachments: 'Anteckningar och bilagor',
    energySources: 'Energikällor',
    tanks: 'Tankar',
    performance: 'Verkningsgrad',

    // Accumulation tanks
    accumulationTanks: 'Ackumulatortankar',
    addTank: 'Lägg till tank',
    confirmDeleteTank: 'Ta bort denna ackumulatortank?',
    noTanks: 'Inga ackumulatortankar konfigurerade. Klicka för att lägga till.',
    dhwTank: 'VVB (varmvatten)',
    heatingTank: 'Värmebuffert',
    coolingTank: 'Kyllagring',
    insulation: 'Isolering',
    setpoint: 'Börvärde (°C)',
    maxTemp: 'Max temp (°C)',
    minTemp: 'Min temp (°C)',
    heatLoss: 'Värmeförlust (W/K)',

    // Electric boiler insulation (Table J.2)
    boilerInsulation: 'Isoleringsgrad panna',
    boilerInsulationVeryLow: 'Mycket dåligt isolerad',
    selectBoilerInsulation: 'Välj isolering...',

    // Energy source configuration
    energySourceConfig: 'Energikällekonfiguration',
    sourceType: 'Energikällatyp',
    selectType: 'Välj energikällatyp...',
    sourceName: 'Energikällans namn',
    usage: 'Användning',
    dhw: 'VVB',
    addToList: 'Lägg till i listan',

    // Priority list
    priorityList: 'Prioritetslista',
    dragToReorder: 'Tryck för att redigera. Dra för att ändra ordning',
    clickToEdit: 'Klicka på en källa för att redigera',
    confirmDeleteSource: 'Ta bort denna energikälla?',
    noPrioritySources: 'Inga energikällor tillagda ännu',
    noSources:
      'Inga energikällor tillagda ännu. Använd formuläret ovan för att lägga till källor.',

    // Energy source types
    districtHeating: 'Fjärrvärme',
    combustionBoiler: 'Förbränningspanna',
    electricBoiler: 'Elpanna',
    otherSource: 'Annan källa',

    // Heat pump fields
    heatPumpType: 'Värmepumpstyp',
    airToAir: 'Luft-till-luft',
    airToWater: 'Luft-till-vatten',
    liquidToWater: 'Vätska-till-vatten',
    heatingCapacity: 'Värmekapacitet (kW)',
    liquidSource: 'Vätskekälla',
    selectSource: 'Välj källa...',
    freshWater: 'Sötvatten',
    seaWater: 'Havsvatten',
    sourceTemp: 'Källtemperatur (°C)',
    avgYearlyTemp: 'Genomsn. årstemperatur (°C)',
    maxTemperatureSupplied: 'Högsta levererade temperatur (°C)',
    SourceTempeAmplitude: 'Temperaturvariation i värmekällan (°C)',
    energyWellDimensioning: 'Användning och dimensionering av energibrunn',
    energyWellHeatingOnlyUndersized:
      'Endast uppvärmning (värmeuttag), något underdimensionerad energibrunn',
    energyWellHeatingOnlyGood:
      'Endast uppvärmning (värmeuttag), väl dimensionerad energibrunn',
    energyWellSomeCoolingUndersized:
      'Uppvärmning och viss kylning, något underdimensionerad energibrunn',
    energyWellSomeCoolingGood:
      'Uppvärmning och viss kylning, väl dimensionerad energibrunn',
    energyWellBalancedUndersized:
      'Balanserad uppvärmning och kylning, något underdimensionerad energibrunn',
    energyWellBalancedGood:
      'Balanserad uppvärmning och kylning, väl dimensionerad energibrunn',
    highestSourceTemperature: 'Högsta levererade källtemperatur (°C)',
    waterSourceDepth: 'Djup för värmeuttag i sjö/vatten',
    CO2EmissionFactor: 'CO₂-utsläppsfaktor (g/kWh)',

    // District heating / Electric boiler / Other source fields
    maxCapacity: 'Max kapacitet (kW)',
    energyPrice: 'Energipris (per kWh)',
    temperatureFromSource: 'Temperatur från källan (°C)',
    // Combustion boiler fields
    boilerType: 'Panntyp',
    biomass: 'Biomassa',
    fuelSource: 'Bränslekälla',
    otherFuelSource: 'Övrigt',
    fuelType: 'Bränsletyp',
    flueGasCondensation: 'Rökgaskondensering',
    fuelConfig: 'Bränslekonfiguration',
    fuelEnergyContent: 'Energiinnehåll (kWh/L)',
    efficiencyLowLoad: 'Effekt vid 30% last (kW)',
    effectFullLoad: 'Effekt vid full last (kW)',
    isCondensing: 'Kondenserande panna',
    operatingSchedule: 'Driftschema',
    startDate: 'Start (dag/månad)',
    endDate: 'Slut (dag/månad)',
    startOfDay: 'Starttimme',
    endOfDay: 'Sluttimme',
    seasonalMeanTemp: 'Säsongsmedeltemperatur (°C)',

    // Solar thermal fields
    solarType: 'Soltyp',
    vacuumTube: 'Vakuumrör',
    flatPlate: 'Plansolfångare',
    tilt: 'Lutning (°)',
    area: 'Total area (m²)',
    collectorArea: 'Solfångararea (m²)',
    pipeLength: 'Rörlängd (m)',
    pipeUValue: 'Rör U-värde (W/mK)',
    collectorSpecs: 'Solfångarspecifikationer',
    efficiencyNormal: 'Verkningsgrad η₀',
    heatLossLinear: 'Värmeförlust a₁ (W/m²K)',
    heatLossSecond: 'Värmeförlust a₂ (W/m²K²)',
    opticalEfficiency: 'Optisk verkningsgrad',
    heatLossCoeff: 'Värmeförlustkoefficient',
    shadingWinter: 'Skuggfaktor vinter',
    shadingSummer: 'Skuggfaktor sommar',
    adjustmentFactor: 'Justeringsfaktor',
    tankSpiralPlacementFactor: 'Placeringsfaktor för tankspiral',
    temperatureColdWater: 'Kallvattentemperatur (°C)',
    temperatureInCollectionTank: 'Temperatur i ackumulatortank (°C)',
    percentageOfCollectorLoopOutside: 'Andel av solfångarkrets utomhus (%)',
    snowCoverageMonths: 'Snötäckta månader',
    selectMonths: 'Välj månader...',
    insulationFactorForCollectionLoop: 'Isoleringsfaktor för solfångarkrets',
    selectInsulationFactorForCollectionLoop: 'Välj isoleringsfaktor...',

    // District heating tables O.1, O.2, O.3
    heatExchangerInsulation: 'Värmeväxlarisolering',
    selectHeatExchangerInsulation: 'Välj isolering...',
    outletTemperatureRange: 'Utloppstemperaturområde',
    selectOutletTempRange: 'Välj område...',
    outletTempLow: '≤ 50 °C',
    outletTempMedium: '50–70 °C',
    outletTempHigh: '≥ 70 °C',
    bdhCoefficient: 'Värmeväxlarförlust',
    bdhValue: 'Förlustkoefficient',
    supplyTemperatureRange: 'Tillförseltemperaturområde',
    selectSupplyTempRange: 'Välj område...',
    supplyTempHigh: '≥ 150 °C',
    supplyTempMedium: '105–150 °C',
    supplyTempLow: '≤ 105 °C',
    ddhCoefficient: 'Distributionsvärmeförlust',
    ddhValue: 'Förlustkoefficient',
    coolingHeatExchangerInsulation: 'Kylvärmeväxlarisolering',
    selectCoolingHxInsulation: 'Välj isolering...',
    coolingHeatExchangerUValue: 'Kylvärmeväxlare',
    coolingHxUValue: 'U-värde (W/m²K)',

    // CHP tables Q.1, Q.2
    isCHP: 'Kraftvärme (CHP)',
    chpSettings: 'CHP-inställningar',
    chpFuelType: 'CHP bränsletyp',
    selectChpFuelType: 'Välj bränsletyp...',
    chpSolidFuel: 'Fast bränsle',
    chpLiquidFuel: 'Flytande bränsle',
    chpGas: 'Gas',
    chpPerformanceLevel: 'Prestandanivå',
    selectChpPerformance: 'Välj prestanda...',
    chpThermalEfficiency: 'Termisk verkningsgrad (%)',
    chpElectricalEfficiency: 'Elektrisk verkningsgrad (%)',
    chpTotalEfficiency: 'Total verkningsgrad (%)',
    chpBoilerType: 'CHP panntyp',
    selectChpBoilerType: 'Välj panntyp...',
    chpBiopellets: 'Biopellets',
    chpWoodChips: 'Flis',
    gasOrOilBoiler: 'Gas- eller oljepanna',
    chpC7: 'C\u2087',
    chpC8: 'C\u2088',
    chpN: 'n',

    // Solar thermal pipe insulation table H.2
    pipeInsulationType: 'Rörisoleringstyp',
    selectPipeInsulation: 'Välj isolering...',
  },

  // Excess Energy Module
  excessEnergy: {
    eligibleForHarvesting: 'Kvalificerad för energiåtervinning',
    eligibleForHarvestingHelp:
      'Markera denna modul som kvalificerad för överskottsenergiåtervinning',

    // Duct dimensions
    ductDimensions: 'Kanaldimensioner',
    ductShape: 'Kanalform',
    diameter: 'Diameter (mm)',
    width: 'Bredd (mm)',
    height: 'Höjd (mm)',
    airspeed: 'Lufthastighet (m/s)',

    // Flow properties
    flowProperties: 'Flödesegenskaper',
    temperature: 'Frånluftstemperatur (C)',
    volumeFlow: 'Volymflöde',
    volumeFlowAir: 'Volymflöde (m³/h)',
    volumeFlowLiquid: 'Volymflöde (L/h)',

    // Delete
    deleteModule: 'Ta bort överskottsenergimodul',
    confirmDelete: 'Ta bort denna överskottsenergimodul?',
    noModuleFound: 'Ingen överskottsenergimodul hittades',
  },

  // Solar PV Module
  solarPv: {
    soilingFactors: 'Nedsmutsningsfaktorer (\u03C6_soil)',
    panelProperties: 'Panelegenskaper',
    lossesCoefficients: 'Förluster och koefficienter',
    panelAngle: 'Panelvinkel',
    tiltRange: 'Lutningsområde: {range}°',
    angleOutOfRange: 'Vinkel utanför området',
    selectLocation: 'Välj plats...',
    usingStandardTable:
      'Använder {standard} tabell för lutningsområde {range}°',
    selectCellType: 'Välj celltyp...',
    nominalEfficiency: 'Nominell verkningsgrad (0-1)',
    panelAzimuth: 'Panel-azimut (0-360°)',
    shadingFactor: 'Skuggfaktor (0-1)',
    mountingType: 'Monteringstyp',
    selectMountingType: 'Välj monteringstyp...',
    windExposure: 'Vindexponering',
    selectWindExposure: 'Välj vindexponering...',
    heatLossFactor: 'Värmeförlustfaktor (W/m²K)',
    inverterEfficiency: 'Växelriktarverkningsgrad (0-1)',
    degradationLoss: 'Degraderingsförlust (0-1)',
    inverterLoss: 'Växelriktarförlust (0-1)',
    transmissionProduct: 'Transmissionsprodukt (0-1)',
    temperatureCoefficient: 'Temperaturkoefficient (%/°C)',
    incidentAngleModifier: 'Infallsvinkelmodifierare (0-1)',
    deleteModule: 'Ta bort solcellsmodul',
    confirmDelete: 'Ta bort denna solcellsmodul?',
  },

  // Battery edit page
  battery: {
    annualSimOnly:
      'Batterier ingår för närvarande endast i årssimuleringar. De ingår ännu inte i beräkningen av energimärkningen.',
    maxCapacity: 'Max kapacitet (kWh)',
    maxChargePower: 'Max laddeffekt (kW)',
    maxDischargePower: 'Max urladdningseffekt (kW)',
    chargeEfficiency: 'Laddningsverkningsgrad (0-1)',
    dischargeEfficiency: 'Urladdningsverkningsgrad (0-1)',
    minStateOfCharge: 'Lägsta laddningsnivå (0-1)',
    maxStateOfCharge: 'Högsta laddningsnivå (0-1)',
    peakShavingThreshold: 'Gräns för effekttoppar (kW)',
    preChargeStateOfCharge: 'Laddningsnivå för förladdning (0-1)',
    maxCapacityRequired: 'Max kapacitet större än 0 krävs',
    maxChargePowerRequired: 'Max laddeffekt större än 0 krävs',
    maxDischargePowerRequired: 'Max urladdningseffekt större än 0 krävs',
    deleteBattery: 'Ta bort batteri',
    confirmDelete: 'Ta bort detta batteri?',
  },

  // HVAC system type options
  hvacSystemTypes: {
    balanced: 'Balanserad',
    exhaust: 'Frånluft',
    supply: 'Tilluft',
  },

  // HVAC edit page
  hvac: {
    deleteUnit: 'Ta bort VVS-enhet',
    confirmDelete: 'Ta bort denna VVS-enhet?',
    heatRecoveryShort: 'Värmeåtervinning',
    airVolumeShort: 'Luftflöde',
    addDxSystem: 'Lägg till DX-system',
    confirmDeleteDxSystem: 'Ta bort detta DX-system?',
    addHeatingBattery: 'Lägg till värmebatteri',
    confirmDeleteHeatingBattery: 'Ta bort detta värmebatteri?',
    addCoolingBattery: 'Lägg till kylbatteri',
    confirmDeleteCoolingBattery: 'Ta bort detta kylbatteri?',

    // Section headers
    namePlaceholder: 'Namn på ventilationsaggregat',
    dxSystemNamePlaceholder: 'Namn på DX-system',
    batteryNamePlaceholder: 'Namn på batteri',
    flowSfpSettings: 'Luftflöde och SFP-inställningar',
    temperatureMeasurements: 'Temperaturmätningar',
    dxSystems: 'DX (Direktexpansion)',
    heatingBatteries: 'Värmebatterier',
    coolingBatteries: 'Kylbatterier',
    naturalVentilation: 'Naturlig ventilation',

    // SFP fields
    sfpCalculationMethod: 'SFP-beräkningsmetod',
    sfpAsFunction: 'Specifik fläkteffekt',
    yearBands: {
      pre1985: 'Före 1985',
      '1985to1995': '1985 till 1995',
      '1995to2005': '1995 till 2005',
      '2005to2013': '2005 till 2013',
      '2013to2020': '2013 till 2020',
      from2020: '2020 och nyare',
    },
    suggestions: {
      yearHelp:
        'Året ventilationsaggregatet installerades. Det avgör typisk motortyp, SFP och värmeåtervinning för perioden.',
      hintLabel: 'Förslag',
      calculatedLabel: 'Beräknat',
      apply: 'Använd',
      applyAll: 'Använd ({count}) förslag',
      noSuggestions: 'Inga förslag',
      applyAllHelp: 'Använd alla föreslagna värden på denna sida.',
    },

    // Flow fields
    fanPower: 'Fläkteffekt',
    coverage: 'Täckning',
    fanPowerIn: 'Fläkteffekt tilluft (kW)',
    fanPowerOut: 'Fläkteffekt frånluft (kW)',
    supplyAirVolume: 'Supply Air Volume',
    airVolumeOperating: 'Operating (m³/h)',
    airVolumeCapacity: 'Capacity (m³/h)',
    airVolumeNonOperating: 'Non-Operating (m³/h)',
    extractionAirVolume: 'Extraction Air Volume',
    airVolumeExtractionOperating: 'Operating (m³/h)',
    airVolumeExtractionCapacity: 'Capacity (m³/h)',
    airVolumeExtractionNonOperating: 'Non-Operating (m³/h)',

    // Heat recovery
    heatRecoveryType: 'Värmeåtervinningstyp',
    efficiencyHR: 'Verkningsgrad VÅ (%)',
    frostProtection: 'Frostskydd',
    frostProtectionTemperature: 'Frostskyddstemperatur (°C)',

    // Temperature
    measuredSupplyTemp: 'Uppmätt tilluftstemp (°C)',
    measuredExhaustTemp: 'Uppmätt frånluftstemp (°C)',

    // DX System
    dxSystem: 'DX-system',
    dxType: 'Typ',

    // Battery fields
    heatingBattery: 'Värmebatteri',
    coolingBattery: 'Kylbatteri',
    batteryType: 'Typ',

    // Priority lists
    heatingPriorityList: 'Värmeprioritet',
    coolingPriorityList: 'Kylprioritet',
    priorityListHelp: 'Dra för att ändra prioritet för beräkningar',
    noPriorityItems: 'Inga objekt konfigurerade',

    // zone linking
    linkedZones: 'Kopplade zoner',
    noLinkedZones: 'Inga zoner kopplade',
    manageZones: 'Hantera zoner',
    useZoneMap: 'Använd zonkarta',
    linkZonesTitle: 'Koppla termiska zoner',
    noZonesAvailable: 'Inga termiska zoner tillgängliga',
    zonesLinked: 'Zoner länkade',
    noZoneWarning:
      'Denna ventilationsenhet är inte kopplad till en termisk zon.',
    noZoneListWarning: '{name} är inte kopplad till en termisk zon.',
    sfp100Required: 'SFP @ 100% större än 0 krävs',
    airVolumeOperatingRequired: 'Tilluftens driftvolym större än 0 krävs',
    airVolumeCapacityRequired: 'Tilluftens kapacitet större än 0 krävs',
    airVolumeExtractionOperatingRequired:
      'Frånluftens driftvolym större än 0 krävs',
    dxEnergySourceRequired: 'Varje DX-system behöver en energikälla',
    dxSystemEfficiencyRequired:
      'Varje DX-system behöver en systemverkningsgrad större än 0',
    heatingBatteryPowerRequired:
      'Varje värmebatteri behöver en effekt större än 0',
    heatingBatterySystemEfficiencyRequired:
      'Varje värmebatteri behöver en systemverkningsgrad större än 0',
    heatingBatteryEnergySourceRequired:
      'Varje värmebatteri behöver en energikälla',
    coolingBatteryPowerRequired:
      'Varje kylbatteri behöver en effekt större än 0',
    coolingBatterySystemEfficiencyRequired:
      'Varje kylbatteri behöver en systemverkningsgrad större än 0',
    coolingBatteryEnergySourceRequired:
      'Varje kylbatteri behöver en energikälla',

    supplementaryFactor: 'Tilläggsfaktor',

    motorType: 'Motortyp',
    motorTypes: {
      none: 'Ingen',
      belt: 'Remdrift',
      axial: 'Axialfläkt',
      EC: 'EC-motor',
      AC: 'AC-motor',
      DC: 'DC-motor',
      VSD: 'Frekvensomriktare (VSD)',
      other: 'Annat',
    },

    dxTypes: {
      cooling: 'Endast kylning',
      heating: 'Endast uppvärmning',
      both: 'Både uppvärmning och kylning',
    },

    flowTypes: {
      variable: 'Variabelt luftflöde',
      constant: 'CAV, konstant luftflöde',
      optimal: 'DCV, behovsstyrd',
    },

    batteryTypes: {
      water: 'Vatten',
      electric: 'Elektrisk',
      heatPump: 'Värmepump',
      other: 'Annat',
    },

    heatRecoveryTypes: {
      rotaryWheel: 'Roterande värmeväxlare',
      crossFlow: 'Korsströms plattvärmeväxlare',
      plateCounterflow: 'Motströms plattvärmeväxlare',
      runAroundCoil: 'Vätskekopplat batteri',
      heatPipe: 'Värmerör',
      none: 'Ingen',
    },
  },

  // Exterior wall edit page
  exteriorWall: {
    namePlaceholder: 'Väggnamn',
    direction: 'Riktning',
    type: 'Väggtyp',
    shadingFactor: 'Skuggfaktor',
    deleteWall: 'Radera vägg',
    confirmDelete: 'Radera denna vägg?',
    directionRequired: 'Vänligen välj en riktning för väggen',
    areaRequired: 'Väggyta större än 0 krävs',
    uValueRequired: 'U-värde större än 0 krävs',
    windowsExceedArea: 'Total fönsterarea överstiger väggarean.',
    doorsExceedArea: 'Total dörrarea överstiger väggarean.',
    gatesExceedArea: 'Total portarea överstiger väggarean.',
    combinedExceedArea:
      'Kombinerad area av fönster, dörrar och portar överstiger väggarean.',
    windowsExceedAreaList: '{name}: total fönsterarea överstiger väggarean.',
    doorsExceedAreaList: '{name}: total dörrarea överstiger väggarean.',
    gatesExceedAreaList: '{name}: total portarea överstiger väggarean.',
    combinedExceedAreaList:
      '{name}: kombinerad area av fönster, dörrar och portar överstiger väggarean.',
    options: {
      custom: 'Anpassad',
      standard: 'Standard',
      timberFrame36_150: 'Träram 36mm, 150mm isolering',
      timberFrame36_200: 'Träram 36mm, 200mm isolering',
      timberFrame36_250: 'Träram 36mm, 250mm isolering',
      timberFrame48_150: 'Träram 48mm, 150mm isolering',
      timberFrame48_200: 'Träram 48mm, 200mm isolering',
      timberFrame48_250: 'Träram 48mm, 250mm isolering',
      epsBlock310: 'EPS-block 310mm (140mm betongkärna)',
      epsBlock370: 'EPS-block 370mm (140mm betongkärna)',
      epsBlock430: 'EPS-block 430mm (140mm betongkärna)',
      iProfile200: 'I-profil stålram, 200mm isolering',
      iProfile300: 'I-profil stålram, 300mm isolering',
      iProfile400: 'I-profil stålram, 400mm isolering',
      lwaBlock250: 'Lättklinkerblock (Isoblokk) 250mm',
      lwaBlock300: 'Lättklinkerblock (Isoblokk) 300mm',
      lwaBlock350: 'Lättklinkerblock (Isoblokk) 350mm',
      slottedSteel200: 'Slitsad stål, 200mm isolering',
      slottedSteel250: 'Slitsad stål, 250mm isolering',
      slottedSteel300: 'Slitsad stål, 300mm isolering',
      unslottedSteel200: 'Oslitsad stål, 200mm isolering',
      unslottedSteel250: 'Oslitsad stål, 250mm isolering',
      unslottedSteel300: 'Oslitsad stål, 300mm isolering',
    },
  },

  // Building types (NS 3031 categories)
  buildingTypes: {
    label: {
      smallHouse: 'Småhus',
      apartmentBlock: 'Flerbostadshus',
      kindergarten: 'Förskola',
      officeBuilding: 'Kontor',
      schoolBuilding: 'Skola',
      universityCollege: 'Universitet/Högskola',
      hospital: 'Sjukhus',
      nursingHome: 'Äldreboende',
      hotelBuilding: 'Hotell',
      sportsBuilding: 'Idrott',
      commercialBuilding: 'Handel',
      culturalBuilding: 'Kultur',
      lightIndustry: 'Lätt industri/Lager',
    },
    description: {
      smallHouse:
        'Enfamiljshus, parhus, radhus, kedjehus eller andra små bostadsbyggnader.',
      apartmentBlock:
        'Flerbostadshus med två eller fler våningar, inklusive stora radhus med flera våningar.',
      kindergarten: 'Byggnader avsedda för förskola eller tidig barnomsorg.',
      officeBuilding:
        'Enkla kontor, kontor med ventilation och kylning, eller utställnings-/kongressbyggnader.',
      schoolBuilding:
        'Undervisningslokaler, inklusive skolor med simhall eller idrottshall.',
      universityCollege:
        'Universitets- eller högskolebyggnader, laboratoriebyggnader eller forskningsanläggningar.',
      hospital:
        'Sjukhus, patienthotell eller laboratoriebyggnader för medicinskt bruk.',
      nursingHome: 'Äldreboenden för långtidsvård.',
      hotelBuilding:
        'Hotell, restaurangbyggnader eller andra byggnader för logi.',
      sportsBuilding:
        'Idrottshallar, simhallar och andra idrottsanläggningar med duschområden.',
      commercialBuilding:
        'Butiker, affärer med kyl-/frysrum eller bensinstationer.',
      culturalBuilding: 'Biografer, museer, bibliotek och religiösa byggnader.',
      lightIndustry:
        'Industribyggnader, lagerbyggnader, fiskeri-/jordbruksbyggnader, energiförsörjningsanläggningar eller andra verkstäder.',
    },
  },

  buildingSubcategories: {
    1: 'Enfamiljshus',
    2: 'Enfamiljshus med uthyrningsdel',
    3: 'Tvåfamiljshus (horisontellt)',
    4: 'Tvåfamiljshus (vertikalt)',
    5: 'Fyrfamiljshus',
    6: 'Kedjehus',
    7: 'Radhus',
    8: 'Fritidsbostad',
    9: 'Annat småhus',
    10: 'Lägenhet',
    11: 'Annan bostad',
    12: 'Förskolebyggnad',
    13: 'Enkla kontor',
    14: 'Kontor med ventilation och kyla',
    15: 'Mäss-/kongressbyggnad',
    16: 'Annan kontorsbyggnad',
    17: 'Undervisningslokaler',
    18: 'Skola med simhall',
    19: 'Skola med idrottshall',
    20: 'Undervisningsbyggnad',
    21: 'Laboratoriebyggnad',
    22: 'Annan forskningsbyggnad',
    23: 'Sjukhus',
    24: 'Sjukhushotell',
    25: 'Sjukhuslaboratorium',
    26: 'Vårdhem',
    27: 'Hotellbyggnad',
    28: 'Övernattningsbyggnad',
    29: 'Restaurangbyggnad',
    30: 'Annan hotellbyggnad',
    31: 'Idrottshall',
    32: 'Idrottshall med duschanläggning',
    33: 'Idrottshall med simhall',
    34: 'Butik',
    35: 'Butik med kylrum',
    36: 'Bensinstation',
    37: 'Kulturbyggnad',
    38: 'Biograf',
    39: 'Museum/bibliotek',
    40: 'Byggnad för religiösa aktiviteter',
    41: 'Industribyggnad',
    42: 'Energiförsörjningsbyggnad',
    43: 'Lagerbyggnad',
    44: 'Fiskeri-/jordbruksbyggnad',
    45: 'Annan industri',
  },

  thermalZones: {
    schedule: {
      heatingSchedule: 'Uppvärmningsschema',
      coolingSchedule: 'Kylschema',
      addHeatingSchedule: 'Lägg till värmeschema',
      addCoolingSchedule: 'Lägg till kylschema',
    },
    yearPeriods: {
      TEK50: 'Före 1969',
      TEK70: '1970 - 1979',
      TEK80: '1980 - 1986',
      TEK87: '1987 - 1996',
      TEK97: '1997 - 2006',
      TEK07: '2007 - 2009',
      TEK10: '2010 - 2016',
      TEK17: '2017 och senare',
    },
    hasFloorToGround: 'Zonen har golv mot mark',
    hasRoof: 'Zonen har yttertak',
    isBasement: 'Zonen är en källare',
    floor: {
      type: 'Typ av golv mot mark',
      area: 'Golv mot mark (m²)',
      options: {
        custom: 'Anpassad',
        standard: 'Standard',
        tiles: 'Kakel på betong',
        parquetChipBoard: 'Parkett på spånskiva',
        carpetConcrete: 'Matta på betong',
      },
    },
    roof: {
      type: 'Taktyp',
      optionsTitle: 'Takkonstruktion',
      angle: 'Takvinkel',
      hasWindows: 'Yttertaket har fönster',
      areaRequired: 'Takyta större än 0 krävs',
      windowArea: 'Fönsterarea (m²)',
      glassType: 'Glastyp',
      pitchTypes: {
        flat: 'Platt tak',
        lowSlope: 'Låg lutning',
        gentlePitch: 'Svag lutning',
        standardPitch: 'Standard lutning',
        steepPitch: 'Brant lutning',
        verySteepPitch: 'Mycket brant lutning',
      },
      options: {
        custom: 'Anpassad',
        standard: 'Standard',
        compactConcrete200: 'Kompakttak, betong, 200mm isolering',
        compactConcrete300: 'Kompakttak, betong, 300mm isolering',
        compactConcrete400: 'Kompakttak, betong, 400mm isolering',
        compactSteel200: 'Kompakttak, stål, 200mm isolering',
        compactSteel300: 'Kompakttak, stål, 300mm isolering',
        compactSteel400: 'Kompakttak, stål, 400mm isolering',
        pitched48mm200: 'Sadeltak, 48mm takstolar, 200mm isolering',
        pitched48mm300: 'Sadeltak, 48mm takstolar, 300mm isolering',
        pitched48mm400: 'Sadeltak, 48mm takstolar, 400mm isolering',
        pitchedIBeam200: 'Sadeltak, I-balkar, 200mm isolering',
        pitchedIBeam300: 'Sadeltak, I-balkar, 300mm isolering',
        pitchedIBeam450: 'Sadeltak, I-balkar, 450mm isolering',
        coldAttic200: 'Kallvind, 200mm isolering',
        coldAttic300: 'Kallvind, 300mm isolering',
        coldAttic450: 'Kallvind, 450mm isolering',
      },
    },
    basement: {
      dimensions: 'Dimensioner',
      area: 'Golvarea mot mark (m²)',
      wallPerimeter: 'Exponerad väggomkrets (m)',
      fillHeight: 'Djup under mark (m)',
      wallThickness: 'Väggtjocklek (m)',
      wallConstruction: 'Källarvägg',
      wallConstructionType: 'Väggtyp',
      wallUValue: 'U-värde vägg (W/m²K)',
      floorConstruction: 'Källargolv',
      floorConstructionType: 'Golvtyp',
      floorUValue: 'U-värde golv (W/m²K)',
      intro:
        'Kom ihåg att minska golv mot mark i zonen ovanför med källararean.',
      floorConstructionOptions: {
        none: 'Ingen',
        standard: 'Standard',
        concrete100: 'Betong på mark med 100mm isolering',
        concrete150: 'Betong på mark med 150mm isolering',
        concrete200: 'Betong på mark med 200mm isolering',
        concrete250: 'Betong på mark med 250mm isolering',
        concrete300: 'Betong på mark med 300mm isolering',
        concrete350: 'Betong på mark med 350mm isolering',
        concrete400: 'Betong på mark med 400mm isolering',
        wood200: 'Träbjälklag med 200mm isolering',
        wood250: 'Träbjälklag med 250mm isolering',
        wood300: 'Träbjälklag med 300mm isolering',
      },
    },
    groundConditions: {
      type: 'Marktyp',
      thermalConductivity: 'Värmeledningsförmåga λ (W/(m·K))',
      heatCapacity: 'Värmekapacitet Cv (Wh/(m³·K))',
      penetrationDepth: 'Periodisk inträngningsdjup δ (m)',
      options: {
        clay: 'Lera/silt',
        sand: 'Sand/grus',
        rock: 'Berg',
      },
    },
    thermalMass: {
      buildingHeatCapacity: 'Zonens värmekapacitet',
      heatCapacityCategory: 'Värmekapacitetskategori',
      normalizedHeatCapacity: 'Normaliserad värmekapacitet (Wh/m²K)',
      interiorWalls: 'Innerväggar',
      cladding: 'Beklädnad',
      heatCapacity: 'Värmekapacitet (Wh/m²K)',
      furniture: 'Möbler',
      furnitureGrade: 'Möbelgrad',
      massFactor: 'Massfaktor (Wh/m²K)',
      heatCapacityCategoryRequired: 'Vänligen välj en värmekapacitetskategori',
      claddingRequired: 'Vänligen välj en beklädnad',
      furnitureGradeRequired: 'Vänligen välj en möbelgrad',
      labelFirstOption: 'Mycket lätt zon',
      labelSecondOption: 'Lätt zon',
      labelThirdOption: 'Medeltung zon',
      labelFourthOption: 'Tung zon',
      labelFifthOption: 'Mycket tung zon',
      shortDescriptionFirstOption:
        'Lätt bjälklag, tunt golvbeläggning, lätta väggar',
      shortDescriptionSecondOption:
        'Akustiskt undertak, matta över betong, lätta väggar',
      shortDescriptionThirdOption:
        'Lite exponerad betong (20%), parkett över betong',
      shortDescriptionFourthOption: 'Huvudsakligen exponerad betong (70%)',
      shortDescriptionFifthOption: 'Exponerad betong i tak, väggar och golv',
      claddingOptions: {
        custom: 'Anpassad',
        standard: 'Standard',
        concrete100: '100mm (eller mer) betong',
        concrete80: '80mm betong',
        aeratedConcrete: 'Lättbetong',
        gypsum13: 'Gips 13mm',
        lightBrick: 'Lätt tegel',
        lwa: 'Lättklinker',
        solidWood40: 'Massivträ (tjocklek över 40mm)',
        woodPanel15: 'Träpanel 15mm',
        heavyBrick: 'Tung (kompakt) tegel',
      },
      furnitureOptions: {
        none: 'Ingen',
        standard: 'Standard',
        light: 'Lätt',
        medium: 'Medium',
        heavy: 'Tung',
      },
    },
    airLeakage: {
      tekStandard: 'TEK-standard',
      n50: 'Läckagetal n50 (h⁻¹)',
      tekOptions: {
        TEK50: 'Byggregler 1950–1969',
        TEK70: 'Byggregler 1970–1979',
        TEK80: 'Byggregler 1980–1986',
        TEK87: 'TEK 87 (1987-1996)',
        TEK97: 'TEK 97 (1997-2006)',
        TEK07: 'TEK 07 (2007-2009)',
        TEK10: 'TEK 10 (2010-2016)',
        TEK17: 'TEK 17 (2017+)',
      },
    },
    windows: {
      deleteWindow: 'Ta bort fönster',
      confirmDelete: 'Ta bort detta fönster?',
      gValue: 'g-värde',
      frameFraction: 'Karmfaktor',
      shadingFactor: 'Skuggfaktor (0-1)',
      externalBlinds: 'Utvändiga persienner (gt)',
      externalBlindsGt: 'Utvändiga persienner gt',
      externalScreen: 'Utvändig markis (gt)',
      externalScreenGt: 'Utvändig markis gt',
      internalShading: 'Invändig solskydd (gt)',
      internalShadingGt: 'Invändig solskydd gt',
      windowTypes: {
        none: 'Ingen',
        custom: 'Anpassad',
        singleGlass: 'Enkelglas',
        twoLayerGlass: '2-skikts kopplat glas',
        twoLayerEnergyGlass: '2-skikts energiglas',
        twoLayerSolarReflective: '2-skikts solreflekterande glas',
        threeLayerEnergyGlass: '3-skikts energiglas',
      },
    },
    doors: {
      deleteDoor: 'Ta bort dörr',
      confirmDelete: 'Ta bort denna dörr?',
      type: 'Dörrtyp',
      doorTypes: {
        custom: 'Anpassad',
        standard: 'Standard',
        insulated: 'Isolerad',
        normal: 'Normal',
        wellInsulated: 'Välisolerad',
        uninsulated: 'Oisolerad',
      },
    },
    gates: {
      deleteGate: 'Ta bort port',
      confirmDelete: 'Ta bort denna port?',
      type: 'Porttyp',
      gateTypes: {
        custom: 'Anpassad',
        standard: 'Standard',
        insulated: 'Isolerad',
        sectional: 'Sektionsport',
        roller: 'Rullport',
        wellInsulated: 'Välisolerad',
      },
    },
    internalLoads: {
      internalLoadsNotice:
        'Dessa värden används inte vid energimärkning. Endast närvarostyrning för belysning tas med.',
      hotWater: 'Varmvatten',
      equipment: 'Teknisk utrustning',
      occupancy: 'Personer',
      weekday: 'Vardag (260 dagar)',
      weekend: 'Helg (105 dagar)',
      resetToStandards: 'Återställ till',
      hourlyProfile: 'Timprofil',
      editHourlyValues: 'Redigera timvärden',
      peak: 'Topp',
      avg: 'Snitt',
      daily: 'Daglig',
      annual: 'Årlig',
      appliances: 'Vitvaror',
      appliancesDescription:
        'Minska elbehovet genom att ansluta vitvaror till varmvatten.',
      dishwasherLabel: 'Diskmaskin (varmvatten)',
      washingMachineLabel: 'Tvättmaskin (varmvatten)',
      tumbleDryerLabel: 'Torktumlare (varmvatten)',
      applianceShareLabel: 'Termisk andel [%]',
      heatGainShareLabel: 'Värmetillskott till zon [1-100%]',
      lampTypes: 'Lamptyper',
      lampType: 'Lamptyp',
      selectLampType: 'Välj lamptyp',
      ballast: 'Driftdon',
      electronic: 'Elektronisk',
      electromechanical: 'Elektromekanisk',
      sharePercent: 'Andel (%)',
      efficiencyFactorFL: 'Effektivitetsfaktor (FL)',
      lampTypeNames: {
        ledNew: 'LED från 2016 och nyare',
        ledOld: 'LED från 2010–2015',
        fluorescentT5: 'Lysrör T5',
        fluorescentT8: 'Lysrör T8',
        metalHalide: 'Metallhalogenlampa',
        highPressureSodium: 'Högtrycksnatriumlampa',
        compactFluorescent: 'Kompaktlysrör',
        halogen: 'Halogenlampa',
        incandescent: 'Glödlampa',
      },
      addLampType: 'Lägg till lamptyp',
      deleteLampType: 'Ta bort denna lamptyp?',
    },
    heatingEmissionSystem: 'Värmeavgivningssystem',
    heatingEmissionSystems: {
      radiator_thermostat_80_60:
        'Radiator/konvektor med termostatventil eller lokal rumsregulator',
      radiator_thermostat_60_40:
        'Radiator/konvektor med termostatventil eller lokal rumsregulator',
      radiator_thermostat_40_35:
        'Radiator/konvektor med termostatventil eller lokal rumsregulator',
      radiator_sd_80_60: 'Radiator/konvektor ansluten till BMS',
      radiator_sd_60_40: 'Radiator/konvektor ansluten till BMS',
      radiator_sd_40_35: 'Radiator/konvektor ansluten till BMS',
      fan_coil_heat_pump:
        'Fläktkonvektor / värmepump innedel / aktiv kylbaffel / uppvärmning via ventilationsluft',
      floor_heating_thermostat:
        'Golvvärme med termostatventil eller lokal rumsregulator',
      floor_heating_sd: 'Golvvärme ansluten till BMS',
      panel_heater_pre_2010: 'Panelov – före 2010',
      panel_heater_post_2010: 'Panelov – efter 2010',
    },
    coolingEmissionSystem: 'Kylavgivningssystem',
    coolingEmissionSystems: {
      chilled_beam_thermostat:
        'Passiv kylbaffel med termostatventil eller lokal rumsregulator',
      chilled_beam_sd: 'Passiv kylbaffel ansluten till BMS',
      fan_coil_cool_pump:
        'Aktiv kylbaffel / fläktkonvektor med lokal rumsregulator',
      fan_coil_cool_pump_sd:
        'Aktiv kylbaffel / fläktkonvektor ansluten till BMS',
      floor_cooling_thermostat: 'Golvkylning med lokal rumsregulator',
      floor_cooling_sd: 'Golvkylning ansluten till BMS',
      chilled_ceiling_thermostat: 'Kyltak med lokal rumsregulator',
      chilled_ceiling_sd: 'Kyltak anslutet till BMS',
    },
    effectiveSetpoint: 'Effektiv börvärde',
  },

  // Thermal Zone Links
  thermalZoneLinks: {
    linkZones: 'Länka zoner',
    resetLayout: 'Återställ layout',
    resetLayoutConfirm:
      'Återställa kartlayouten? Alla zoner återgår till den föreslagna placeringen.',
    confirmLink: 'Bekräfta länk',
    linkDialogTitle: 'Länka termiska zoner',
    linkingZones: 'Länkar zoner',
    sourceZone: 'Källzon',
    targetZones: 'Målzoner',
    areaUnit: 'm²',
    uValueUnit: 'W/m²K',
    selectSourceFirst: 'Välj källzon först, sedan målzoner',
    minTwoZones: 'Välj minst 2 zoner att länka',
    linkSuccess: 'Zoner länkade',
    externalZone: 'Extern zon',
    zoneConnections: 'Zonkoppling',
    addConnection: 'Lägg till koppling',
    noConnections: 'Inga zonkopplingar',
    connectionDeleted: 'Koppling borttagen',
    deleteConnectionError: 'Kunde inte ta bort kopplingen',
    connectionAdded: 'Koppling tillagd',
    connectionUpdated: 'Koppling uppdaterad',
    editConnection: 'Redigera koppling',
    deleteConnection: 'Ta bort koppling',
    confirmDeleteConnection: 'Ta bort zonkoppling?',
    connectToExisting: 'Befintlig zon',
    connectToExternal: 'Extern zon',
    chooseConnectionType: 'Anslut till',
    zoneMap: 'Zonkarta',
    zoneMapEmpty: 'Inga zonkopplingar',
    notLinked: 'Inte kopplad',
    autoLinked: 'Automatiskt kopplad',
    linkModeHintSource: 'Klicka på källzonen',
    deleteModeHint: 'Klicka på zonen du vill ta bort kopplingar från',
    ventilation: 'Ventilation',
    zoneMapSubtitle: 'Flytta zonerna för att anpassa layouten.',
    noVentilationUnits: 'Inga ventilationsenheter tillgängliga',
    noHeatingCoolingModules: 'Ingen värme eller kyla tillgänglig',
    linkAny: 'Koppla',
    linkModeHintSourceAny: 'Klicka på källan',
    linkModeHintTargetAny: 'Klicka på målet, eller välj extern zon',
    deleteModeHintAny:
      'Klicka på zonen eller ventilationsenheten du vill ta bort kopplingar från',
    linkModeHintTarget: 'Klicka på målzonen eller välj extern zon',
  },

  analytics: {
    energyToggle: 'Energi',
    analyticsToggle: 'Analys',
    compareToggle: 'Jämför',
    runSimulation: 'Kör simulering',
    runCoverNeedSimulation: 'Kör minimikravsimulering',
    coverNeedTooltip:
      'Kör simuleringen med fiktiva system enligt minimikrav, så att hela energibehovet täcks där system saknas eller inte räcker till',
    coverNeedAssumptionsTitle: 'Antaganden i minimikravsimuleringen',
    simulating: 'Simulerar...',
    exportToExcel: 'Exportera till Excel',
    sendToEnova: 'Skicka till Enova',
    resendToEnova: 'Skicka till Enova igen',
    downloadEnovaPdf: 'Ladda ner Enova PDF',
    sentToEnovaSuccess: 'Skickat till Enova',
    sendToEnovaError: 'Kunde inte skicka till Enova',
    simulationStartedRefresh:
      'Beräkningarna har startat, uppdatera eller gå tillbaka till sidan efter 10 sekunder',
    simulationStartError: 'Kunde inte starta simuleringen',
    runRequiresZoneSelection: 'Välj minst en zon innan du kör simuleringen.',
    solarNotIncludedInZones:
      'Solproduktion beräknas på byggnadsnivå och ingår inte i resultat och jämförelser per zon.',
    resultsCalculatedAt: 'Beräknad {datetime}',
    resultsCalculatedWithStandard: 'Beräknad {datetime} enligt {standard}',
    enovaMissingTiltakDescription:
      'Fyll i beskrivningen under Åtgärder i Energimärkning.',
    enovaNoIncludedActions:
      'Aktivera minst en åtgärd att inkludera, eller avmarkera Inkludera åtgärder och ange en beskrivning.',
    enovaMissingActionDescriptions: 'Fyll i beskrivningar för: {actions}',
    enovaMissingCredentials:
      'Fyll i {fields} i din användarprofil innan du skickar till Enova.',
    enovaNoMatrikkelSelected:
      'Välj minst en bruksenhet i Matrikkeldata-sektionen innan du skickar till Enova.',
    enovaZonesNotSimulated:
      'Kör energimärkningssimuleringen för de valda zonerna innan du skickar till Enova.',
    enovaNonResidentialMultipleUnits:
      'Endast en enhet kan väljas för icke-bostadssektioner.',
    confirmSendToEnovaMessage: 'Är du säker på att du vill skicka till Enova?',
    enovaSendWithMessagesWarning:
      'Simuleringen har {count} meddelanden. Kontrollera dem innan du skickar till Enova.',
    simulationProgress: 'Kör byggnadsenergsimulering...',
    simulationMessages: 'Simuleringsmeddelanden',
    energyCalcWithStandard: 'Energiberäkningar enligt {standard}-standarden.',
    energyCalc: 'Energiberäkningar',
    noResults:
      'Inga simuleringsresultat tillgängliga. Kör en simulering för att se energidata.',
    analyticsPlaceholder: 'Analysdiagram kommer att visas här.',
    monthlyEnergyBudget: 'Månadsvis energibudget (behov)',
    deliveredEnergyTitle: 'Levererade energikällor',
    deliveredEnergyDesc:
      'Total levererad energi representerar alla energikällor som levereras till byggnaden.',
    energyComparisonTitle: 'Energijämförelse (Netto / Förlust / Brutto)',
    energyComparisonDesc:
      'Jämför netto energibehov, distributionsförluster och brutto energi för varje kategori. Brutto = Netto + Förlust.',
    showTemperature: 'Visa temperaturlinje',
    energySourcesChartLabel: 'Energikällor',
    totalDeliveredEnergy: 'Total levererad energi',
    visible: 'Synlig',
    noData: 'Ingen data',
    nettEnergy: 'Netto energi',
    grossEnergy: 'Brutto energi',
    distributionLossLabel: 'Distributions- och ackumuleringsförlust',
    noMonthlyData: 'Månadsdata är inte tillgänglig för denna simulering.',
    monthlyChartHelp:
      'Varje staplad stapel representerar det månatliga netto energibehovet uppdelat efter kategori.',
    netEnergyDemand: 'Netto energibehov',
    distributionLosses: 'Distributions- och ackumuleringsförluster',
    grossEnergyDemand: 'Brutto energibehov',
    energySourcesTitle: 'Energikällor (Tillförd energi)',
    deliveredExportedEnergyTitle: 'Levererad och exporterad energi',
    climaCorrectedEnergyTitle:
      'Klimatkorrigerad levererad och exporterad energi',
    netEnergyTitle: 'Nettoenergi (Netto energibehov)',
    distributionLossTitle:
      'Distributionsförluster (Distributions- och ackumuleringsförluster)',
    grossEnergyTitle: 'Bruttoenergi (Brutto energibehov)',
    category: 'Kategori',
    value: 'Värde',
    unit: 'Enhet',
    co2: 'CO₂ kg',
    energyType: 'Energityp',
    electricityCategory: '1. Elektricitet',
    fossilCategory: '2-3. Fossila bränslen',
    renewableCategory: '4. Förnybar uppvärmning',
    districtCategory: '5. Fjärrenergi',
    otherCategory: '6-8. Andra källor',
    totalCategory: 'Totalt',
    elSpecific: 'El. specifika poster',
    elHeating: 'El. för rumsuppvärmning',
    elCooling: 'El. för kylsystem',
    elDHW: 'El. för varmvatten',
    elProducedUsed: 'El. produktion för eget bruk',
    elProducedExported: 'El. produktion exporterad',
    oil: 'Olja',
    gas: 'Gas',
    solidFuel: 'Fast bränsle',
    solidBiofuel: 'Fast biobränsle',
    liquidBiofuel: 'Flytande biobränsle',
    gaseousBiofuel: 'Gasformigt biobränsle',
    districtHeating: 'Fjärrvärme',
    districtCooling: 'Fjärrkyla',
    other: 'Övrigt',
    sumDelivered: 'Totalt',
    spaceHeating: 'Rumsuppvärmning',
    ventilationHeating: 'Ventilationsvärme',
    hotWater: 'Varmvatten',
    spaceCooling: 'Rumskyla',
    ventilationCooling: 'Ventilationskyla',
    fans: 'Fläktar',
    pumps: 'Pumpar',
    lighting: 'Belysning',
    technicalEquipment: 'Teknisk utrustning',
    total: 'Totalt',
    // Heat loss
    heatLossTitle: 'Värmeförlust',
    heatLossDesc:
      'Fördelning av byggnadens värmeförlust per komponent. Värden i W/m²K.',
    hlWalls: 'Väggar',
    hlRoof: 'Yttertak',
    hlFloor: 'Golv mot mark',
    hlWindows: 'Fönster',
    hlDoors: 'Dörrar',
    hlThermalBridge: 'Köldbryggor',
    hlInfiltration: 'Infiltration',
    hlVentilation: 'Ventilation',
    hlTotal: 'Totalt',
    // Värmeförlustbudget (tabell 3 NS 3031:2025)
    hlBudgetTitle: 'Värmeförlustbudget',
    hlBudgetCategory: 'Värmeförlustpost',
    hlBudgetValue: 'Värmeförlusttal',
    hlWindowsDoors: 'Fönster och dörrar',
    hlTransmissionSum: 'Värmeförlusttal, transmission, summa 1–5',
    hlClimateScreenSum: 'Värmeförlusttal, klimatskärm, summa 1–6',
    hlTotalSum: 'Värmeförlusttal, totalt, summa 1–7',
    // Primärenergi
    peDeliveredEnergy: 'Levererad energi (el)',
    peDeliveredFuel: 'Levererat bränsle',
    peDistrictHeating: 'Fjärrvärme',
    peDistrictCooling: 'Fjärrkyla',
    peOtherDelivered: 'Övrig levererad energi',
    peElExport: 'El. produktion för export',
    energyLabelTitle: 'Energimärkning',
    supplementaryEnergyTitle: 'Kompletterande energi',
    primaryEnergyFactorsTitle: 'Primärenergifaktorer',
    carCharging: 'Billaddning',
    otherEnergyNeeded: 'Annat energibehov',
    energyNeedForOtherBuildings: 'Energibehov för andra byggnader',
    peFossilOil: 'Fossil olja',
    peFossilGas: 'Fossil gas',
    peFossilSolid: 'Fast fossilt bränsle',
    peBioOil: 'Bioolja',
    peBioGas: 'Biogas',
    peBioSolid: 'Fast biobränsle',
    ventilationSpecsTitle: 'Ventilation och fläktspecifikationer',
    specificFanPower: 'Specifik fläkteffekt (SFP)',
    specificAirFlowIn: 'Specifikt tilluftsflöde under drifttid',
    specificAirFlowOut: 'Specifikt tilluftsflöde utanför drifttid',
    specificExhaustAirFlowIn: 'Specifikt frånluftsflöde under drifttid',
    specificExhaustAirFlowOut: 'Specifikt frånluftsflöde utanför drifttid',
    hcsHeatingTitle: 'Värmesystem',
    hcsCoolingTitle: 'Kylsystem',
    hcsType: 'Typ',
    hcsHeatingFactor: 'Verkningsgrad värmefaktor',
    hcsCoolingFactor: 'Verkningsgrad kylfaktor',
    hcsEnergyCoverage: 'Energitäckningsgrad',
    hcsInndata: 'Indata',
    hcsInstalledHeatingEffect:
      'Specifik installerad effekt för rumsuppvärmning och ventilationsvärme',
    hcsInstalledCoolingEffect:
      'Specifik installerad effekt för rumskyla och ventilationskyla',
    hcsSetpointInOperation: 'Ekvivalent börvärdestemperatur i drift',
    hcsSetpointOutOfOperation: 'Ekvivalent börvärdestemperatur utanför drift',
    wpeTitle: 'Klimatkorrigerad viktad levererad energi',
    wpeColSource: 'Energikälla',
    wpeColDelivered: 'Klimatkorrigerad levererad och exporterad energi',
    wpeColFactor: 'Viktningsfaktor',
    wpeColWeighted: 'Klimatkorrigerad viktad levererad energi',
    wpeTotal: 'Totalt, summa 1-6',
    wpeElectricity: 'Levererad el',
    wpeSolidBio: 'Levererat fast biobränsle',
    wpeLiquidBio: 'Levererat flytande biobränsle',
    wpeGasBio: 'Levererat biobränsle i gasform',
    wpeSolidFossil: 'Levererat fast fossilt bränsle',
    wpeLiquidFossil: 'Levererat flytande fossilt bränsle',
    wpeGasFossil: 'Levererat fossilt bränsle i gasform',
    wpeDistrictHeating: 'Levererad fjärrvärme',
    wpeDistrictCooling: 'Levererad fjärrkyla',
    wpeOther: 'Andra levererade energibärare',
    wpeElExport: 'Elproduktion till export (avdrag)',
    ekBasisHeader: 'Underlag för energiklassning',
    ekValueHeader: 'Värde',
    ekSpecificWeighted: 'Specifik klimatkorrigerad viktad levererad energi',
    meTitle: 'Uppmätt energianvändning (kWh/år)',
    meColSource: 'Energibärare',
    meColYearGroup: 'År',
    meColAverage: 'Genomsnitt',
    meTotalDelivered: 'Totalt levererad energi',
    meTotalNetDelivered: 'Totalt netto levererad energi (minus ev. export)',
    icTitle: 'Inomhustemperatur',
    icSubtitle: 'Månadsmedelvärde baserat på timvärden',
    icZoneLabel: 'Zon',
    icSingleZoneLabel: 'Inomhustemperatur',
    dhcLocalHeatingElectricity: 'Lokal värme — el',
    dhcLocalHeatingFossilOil: 'Lokal värme — fossil olja',
    dhcLocalHeatingFossilGas: 'Lokal värme — fossil gas',
    dhcLocalHeatingFossilSolid: 'Lokal värme — fast fossilt bränsle',
    dhcLocalHeatingBioOil: 'Lokal värme — bioolja',
    dhcLocalHeatingBioGas: 'Lokal värme — biogas',
    dhcLocalHeatingBioSolid: 'Lokal värme — fast biobränsle',
    dhcLocalDistrictHeating: 'Lokal fjärrvärme',
    dhcLocalHeatPump: 'Lokal värmepump',
    dhcLocalHeatingOther: 'Lokal värme — andra källor',
    dhcCentralHeatPump: 'Central värmepump',
    dhcCentralHeatingElectricity: 'Central värme — el',
    dhcCentralHeatingFossilOil: 'Central värme — fossil olja',
    dhcCentralHeatingFossilGas: 'Central värme — fossil gas',
    dhcCentralHeatingFossilSolid: 'Central värme — fast fossilt bränsle',
    dhcCentralHeatingBioOil: 'Central värme — bioolja',
    dhcCentralHeatingBioGas: 'Central värme — biogas',
    dhcCentralHeatingBioSolid: 'Central värme — fast biobränsle',
    dhcCentralDistrictHeating: 'Central fjärrvärme',
    dhcCentralHeatingOther: 'Central värme — andra källor',
    dhcCentralSolarThermal: 'Central solvärme',
    dhcCentralCogeneration: 'Central kraftvärme',
    dhcLocalCooling: 'Lokal kyla',
    dhcCentralCoolingAirWater: 'Central kyla — luft/vatten',
    dhcCentralCoolingLiquidWater: 'Central kyla — vätska/vatten',
    dhcCentralFreeCooling: 'Central frikyla',
    dhcCentralDistrictCooling: 'Central fjärrkyla',
    // Interna laster
    internalLoadsTitle: 'Interna laster',
    internalLoadEnergyTitle: 'Interna laster - Energibehov',
    internalLoadHeatTitle: 'Interna laster - Värmetillskott',
    ilLighting: 'Belysning',
    ilEquipment: 'Teknisk utrustning',
    ilHotWater: 'Varmvatten',
    ilPeople: 'Personer',
    internalLoadsChartTitle: 'Interna laster (Energibehov vs Värmetillskott)',
    internalLoadsChartDesc:
      'Jämför energibehov och värmetillskott från interna lastkällor.',
    ilEnergyNeed: 'Energibehov',
    ilSpecificEnergyNeed: 'Specifikt energibehov',
    ilSpecificHeatGain: 'Specifikt värmetillskott',
    ilHeatGain: 'Värmetillskott',
    // Month names
    month: 'Månad',
    monthJan: 'Jan',
    monthFeb: 'Feb',
    monthMar: 'Mar',
    monthApr: 'Apr',
    monthMay: 'Maj',
    monthJun: 'Jun',
    monthJul: 'Jul',
    monthAug: 'Aug',
    monthSep: 'Sep',
    monthOct: 'Okt',
    monthNov: 'Nov',
    monthDec: 'Dec',
    // Information table (general + climate)
    bdTitle: 'Information',
    bdParameter: 'Allmänt',
    bdInputValue: 'Indata',
    bdBuildingCategory: 'Byggnadskategori',
    bdBuildingType: 'Byggnadstyp',
    bdYearOfConstruction: 'Byggnadsår',
    bdTekStandard: 'TEK-standard',
    bdCalculationDate: 'Beräkningsdatum',
    bdClimateInformation: 'Klimat',
    bdClimateStationSource: 'Klimatstationskälla',
    bdClimateStation: 'Klimatstation',
    bdClimateCorrectionFactor: 'Klimatkorrektionsfaktor',
    bdYearlyAverageTemperature: 'Årsmedeltemperatur',
    efTitle: 'Energiflöde',
    efColCategory: 'Energipost',
    efColNet: 'Netto energibehov',
    efColDist: 'Distributions- och ackumuleringsförluster',
    efColGross: 'Brutto energibehov',
    efColSpf: 'SPF',
    efColDelivered: 'Tillförd energi',
    efTotal: 'Totalt',
    // Viktningsfaktorer energibärare (T.2 NS 3031:2025)
    wfTitle: 'Viktningsfaktorer energibärare',
    wfType: 'Typ',
    wfWeightFactor: 'Viktningsfaktor',
    wfClimateFactor: 'Klimatgasfaktor (CO²-ekvivalent)',
    wfEnergyPrice: 'Energipris',
    wfOtherWeighting: 'Annan viktning',
    wfElectricity: 'Levererad el',
    wfBioSolid: 'Fast biobränsle',
    wfBioLiquid: 'Flytande biobränsle',
    wfBioGas: 'Biobränsle i gasform',
    wfFossilSolid: 'Fast fossilt bränsle',
    wfFossilLiquid: 'Flytande fossilt bränsle',
    wfFossilGas: 'Fossilt bränsle i gasform',
    wfDistrictHeating: 'Fjärrvärme',
    wfDistrictCooling: 'Fjärrkyla',
    wfOther: 'Övrigt',
    wfExportedElectricity: 'Exporterad el',
    // Distributionssystem
    dsTitle: 'Distributionssystem',
    dsCategory: 'Parameter',
    dsValue: 'Indata',
    dsRoomHeating: 'Rumsuppvärmning',
    dsVentilationHeating: 'Ventilationsvärme',
    dsDhwCirculation: 'Varmvattencirkulation',
    dsRoomCooling: 'Rumskyla',
    dsVentilationCooling: 'Ventilationskyla',
    dsPipeLength: 'Löpande meter distributionsrör per BRA',
    dsPumpPower: 'Specifik pumpeffekt',
    // El (tabell T.2 NS 3031:2025)
    elTitle: 'El',
    elCategory: 'Parameter',
    elValue: 'Indata',
    elSolarEfficiency: 'Årsverkningsgrad för solcellssystem',
    elSolarInstalled: 'Installerad effekt för solcellsanläggning (Ppeak)',
    elSolarCoverage: 'Energitäckning av elspecifikt energibehov från solel',
    elWindCoverage: 'Energitäckning av elspecifikt energibehov från vindkraft',
    elChpEfficiency:
      'Årsgenomsnittlig verkningsgrad för elproduktion i kraftvärme',
    elChpCoverage:
      'Energitäckningsgrad av elspecifikt energibehov från kraftvärme',
  },

  energyLabelConfig: {
    airLeakageTitle: 'Luftläckage',
    airLeakageMeasured: 'Luftläckage uppmätt',
    airLeakageMeasuredDate: 'Mätdatum',
    airLeakageGradeAHint:
      'Betyg A kräver uppmätt luftläckage med mätdatum. Utan detta begränsas betyget till B.',
    actionsTitle: 'Åtgärder',
    includeMeasures: 'Inkludera åtgärder under utvärdering',
    includeActivatedActions: 'Inkludera aktiverade åtgärder',
    loadingActions: 'Laddar åtgärder…',
    actionNameVentilation: 'Ventilationsåtgärd',
    actionNameHeating: 'Värme- och kylåtgärd',
    actionNameLighting: 'Belysningsåtgärd',
    actionNameSolar: 'Solcellsåtgärd',
    actionNameControl: 'Styrning & Reglering åtgärd',
    actionsDescription:
      'Om inga åtgärder ingår, beskriv istället orsaken (t.ex. nybyggnation).',
    includedMeasuresInfo:
      'Listan över inkluderade åtgärder innehåller en bedömning av kostnader och konsekvenser avseende fukt och inomhusklimat för varje enskild energiåtgärd. Listan kan användas som underlag för att planera program för underhåll och uppgradering av byggnaden.',
    description: 'Beskrivning',
    measuredValuesTitle: 'Uppmätta värden',
    measuredValuesCheckbox: 'Uppmätta värden',
    measuredValuesDescription:
      'Energiförbrukningsmätningar per källtyp för de senaste 3 åren.',
    energySourcePlaceholder: 'Energikälla (kWh)',
    addMeasurement: 'Lägg till mätning',
    confirmDeleteMeasurement: 'Ta bort denna mätrad?',
    deliveredElectricity: 'Levererad el (kWh)',
    exportedElectricity: 'Exporterad el (kWh)',
    fossilOil: 'Fossil olja (kWh)',
    fossilGas: 'Fossil gas (kWh)',
    fossilSolidFuel: 'Fossilt fast bränsle (kWh)',
    bioOil: 'Bioolja (kWh)',
    bioGas: 'Biogas (kWh)',
    bioSolidFuel: 'Bio fast bränsle (kWh)',
    districtHeating: 'Fjärrvärme (kWh)',
    districtCooling: 'Fjärrkyla (kWh)',
    other: 'Övrigt (kWh)',
    // matrikkel data accordion
    matrikkelDataTitle: 'Matrikkeldata',
    noUnitsFound: 'Inga enheter hittades',
    street: 'Adress',
    addressCode: 'Adresskod',
    postcode: 'Postnummer',
    city: 'Stad',
    municipality: 'Kommun',
    municipalityNumber: 'Kommunnummer',
    gnrBnr: 'Gnr/Bnr',
    leaseholdNumber: 'Festenummer',
    buildingNumber: 'Byggnadsnummer',
    buildingType: 'Byggnadstyp',
    buildingStatus: 'Byggnadsstatus',
    industryType: 'Branschgrupp',
    unitNumber: 'Enhetsnummer',
    unitId: 'Enhets-ID',
    unitType: 'Enhetstyp',
    sectionNumber: 'Sektionsnummer',
    sectionType: 'Sektionstyp',
  },

  zoneSelection: {
    title: 'Zoner att simulera',
    selectAll: 'Välj alla',
    deselectAll: 'Avmarkera alla',
    selected: '{count} av {total} valda',
  },

  buildingTool: {
    showAll: 'Visa alla',
    hideAll: 'Dölj alla',
    updateZone: 'Uppdatera zon',
    deleteZone: 'Ta bort zon',
    title: 'Byggnadsverktyg',
    description:
      'Rita en polygon på kartan för att markera byggnadens fotavtryck, justera parametrar och skapa en zon med väggar.',
    numberOfFloors: 'Antal våningar',
    floorHeight: 'Våningshöjd (m)',
    startFloor: 'Startvåning',
    wallSegments: 'Väggsegment',
    totalPerimeter: 'Total omkrets',
    creating: 'Skapar...',
    createZoneAndWalls: 'Skapa zon och väggar',
    createSuccess: 'Zon och {count} vägg(ar) skapade',
    createError: 'Kunde inte skapa zon och väggar',
    joinBearings: 'Slå samman efter väderstreck',
    splitBearings: 'Visa alla segment',
    joinButton: 'Slå samman',
    splitButton: 'Dela upp',
    floorArea: 'Golvarea (m²)',
    roofArea: 'Takarea (m²)',
    autoSelect: 'Auto',
    autoSelectHint: 'Klicka på en byggnad för att välja fotavtryck automatiskt',
    noBuildingFound: 'Ingen byggnad hittades',
    createAnother: 'Skapa ny zon',
    autoSelectTooltip: 'Auto-välj',
    drawPolygonTooltip: 'Rita polygon',
    drawStackedTooltip: 'Lägg våning ovanför zon',
    drawStackedTooltipDisabled:
      'Lägg våning ovanför zon (kräver en befintlig zon först)',
    drawStackedHint: 'Klicka på en zon för att lägga en kopia ovanpå',
    snapToggleOn: 'Snäpp på',
    snapToggleOff: 'Snäpp av',
    splitTooltip: 'Dela en zon',
    splitTooltipDisabled: 'Dela en zon (kräver en zon först)',
    splitTargetHint: 'Klicka på en zon för att dela',
    view3dTooltip: '3D-vy',
    splitPanelTitle: 'Dela zon',
    splitPanelDescription:
      'Dra reglagen för att placera snittet. Zonen delas i två halvor.',
    splitPanelPickTargetHint:
      'Klicka på en zon på kartan för att välja vilken som ska delas.',
    splitPanelSplittingZone: 'Delar: {name}',
    splitPanelCutPositionLabel: 'Snittposition: {value}',
    splitPanelCutAngleLabel: 'Snittvinkel: {value}°',
    splitPanelCutLengthLabel: 'Snittlängd: {value}',
    splitPanelCutOffsetLabel: 'Snittförskjutning: {value}',
    splitPanelConfirm: 'Bekräfta delning',
    splitPanelCommitting: 'Delar…',
    errorUpdateZone: 'Misslyckades att uppdatera zon',
    errorCreateStackedZone: 'Misslyckades att lägga till våning ovanför zon',
    errorSplitZone: 'Misslyckades att dela zon',
    errorDeleteZone: 'Misslyckades att ta bort zon',
  },

  underDevelopment: 'Denna sida är under utveckling.',

  // excel export labels for the input data sheet
  excelExport: {
    headerSection: 'Sektion',
    headerName: 'Namn',
    headerParameter: 'Parameter',
    headerValue: 'Värde',
    headerUnit: 'Enhet',
    inputDataSheetName: 'Indata',
    boolYes: 'Ja',
    boolNo: 'Nej',
    sectionThermalZones: 'Termiska zoner',
    sectionExteriorWalls: 'Ytterväggar',
    sectionHvacUnits: 'Ventilationsaggregat',
    sectionHeatingCoolingModules: 'Värme-/kylmoduler',
    sectionCentralEnergyModules: 'Centrala energimoduler',
    sectionHeatPumps: 'Värmepumpar',
    sectionDistrictHeating: 'Fjärrvärme',
    sectionCombustionBoilers: 'Förbränningspannor',
    sectionElectricBoilers: 'Elpannor',
    sectionSolarThermal: 'Solvärme',
    sectionOtherEnergySources: 'Andra energikällor',
    sectionSolarPv: 'Solceller',
    sectionDomesticHotWater: 'Varmvatten',
    sectionPipeConfigurations: 'Rörkonfigurationer',
    sectionProductionEquipment: 'Produktionsutrustning',
    sectionExcessEnergy: 'Överskottsenergi',
    // excel-specific short labels
    area: 'Area',
    uValue: 'U-värde',
    yearInstalled: 'Installationsår',
    energySource: 'Energikälla',
    systemEfficiency: 'Systemverkningsgrad',
    usedForHeating: 'Används för uppvärmning',
    usedForCooling: 'Används för kylning',
    usedForDHW: 'Används för varmvatten',
    maxCapacity: 'Max kapacitet',
    heatingCapacity: 'Värmekapacitet',
    cop: 'COP',
    heatingEffect: 'Värmeeffekt',
    coolingEffect: 'Kyleffekt',
    co2eEmissionFactor: 'CO\u2082e-emissionsfaktor',
    energyPrice: 'Energipris',
    power: 'Effekt',
    // entity prefixes
    prefixWall: 'Vägg',
    prefixWindow: 'Fönster',
    prefixDoor: 'Dörr',
    prefixGate: 'Port',
    prefixPipe: 'Rör',
    prefixHeatingBattery: 'Värmebatteri',
    prefixCoolingBattery: 'Kylbatteri',
    prefixDxSystem: 'DX-system',
    prefixEnergySource: 'Energikälla',
    prefixTank: 'Tank',
    prefixCopEntry: 'COP-post',
    // thermal zones
    heatedFloorArea: 'Uppvärmd golvarea (BRA)',
    numberOfFloors: 'Antal våningar',
    floorHeight: 'Våningshöjd',
    indoorTemperature: 'Starttemperatur',
    zoneClimate: 'Zonklimat',
    airLeakageGrade: 'Luftläckage - Grad',
    airLeakageN50: 'Luftläckage - n50',
    setpointHeating: 'Börvärde - Uppvärmning',
    setpointCooling: 'Börvärde - Kylning',
    thermalBridgeType: 'Köldbrygga - Typ',
    thermalBridgePsiValue: 'Köldbrygga - \u03C8-värde',
    floorType: 'Golv mot mark - Typ',
    floorArea: 'Golv mot mark - Area',
    floorUValue: 'Golv mot mark - U-värde',
    floorHeatLossCoeff: 'Golv mot mark - Värmeförlustkoefficient',
    roofType: 'Yttertak - Typ',
    roofArea: 'Yttertak - Area',
    roofUValue: 'Yttertak - U-värde',
    roofAngle: 'Yttertak - Vinkel',
    roofWindowArea: 'Yttertak - Fönsterarea',
    roofWindowUValue: 'Yttertak - Fönster U-värde',
    roofWindowGValue: 'Yttertak - Fönster g-värde',
    basementArea: 'Källare - Golvarea',
    basementWallPerimeter: 'Källare - Exponerad omkrets',
    basementFillHeight: 'Källare - Djup under mark',
    basementWallThickness: 'Källare - Väggtjocklek',
    basementWallUValue: 'Källare - Vägg U-värde',
    basementFloorUValue: 'Källare - Golv U-värde',
    groundThermalConductivity: 'Mark - Värmeledningsförmåga',
    groundHeatCapacity: 'Mark - Värmekapacitet',
    groundPenetrationDepth: 'Mark - Inträngningsdjup',
    thermalMassCategory: 'Termisk massa - Kategori',
    thermalMassHeatCapacity: 'Termisk massa - Värmekapacitet',
    thermalMassNormalized: 'Termisk massa - Normaliserad värmekapacitet',
    // windows
    gValue: 'g-värde',
    shadingFactor: 'Skuggningsfaktor',
    externalBlinds: 'Utvändiga persienner',
    externalBlindsGt: 'Utvändiga persienner Gt',
    externalScreen: 'Utvändig screen',
    externalScreenGt: 'Utvändig screen Gt',
    internalShading: 'Invändig solskydd',
    internalShadingGt: 'Invändig solskydd Gt',
    // hvac
    heatRecoveryType: 'Värmeåtervinningstyp',
    motorType: 'Motortyp',
    flowType: 'Flödestyp',
    sfpSupply: 'SFP (tilluft)',
    sfpExtract: 'SFP (frånluft)',
    sfpNonOperating: 'SFP ej drift',
    coverageArea: 'Betjäningsarea',
    coverageVolume: 'Betjäningsvolym',
    fanPowerSupply: 'Fläkteffekt (tilluft)',
    fanPowerExtract: 'Fläkteffekt (frånluft)',
    heatRecoveryEfficiency: 'Värmeåtervinningsgrad',
    frostProtection: 'Frostskydd',
    frostProtectionTemperature: 'Frostskyddstemperatur',
    airVolumeOperatingSupply: 'Luftflöde drift (tilluft)',
    airVolumeCapacitySupply: 'Luftflöde kapacitet (tilluft)',
    airVolumeNonOperatingSupply: 'Luftflöde ej drift (tilluft)',
    airVolumeOperatingExtract: 'Luftflöde drift (frånluft)',
    airVolumeCapacityExtract: 'Luftflöde kapacitet (frånluft)',
    airVolumeNonOperatingExtract: 'Luftflöde ej drift (frånluft)',
    supplyTemperature: 'Tilluftstemperatur',
    onlyNaturalPassiveVentilation: 'Endast naturlig/passiv ventilation',
    batteryEer: 'EER',
    systemType: 'Systemtyp',
    coolingOnly: 'Endast kylning',
    ambientTemperature: 'Omgivningstemperatur',
    tankPurpose: 'Syfte',
    tankVolume: 'Volym',
    tankInsulationGrade: 'Isoleringsgrad',
    tankHeatLossCoeff: 'Värmeförlustkoefficient',
    tankSetpointTemp: 'Börvärdestemperatur',
    tankMaxTemp: 'Max temperatur',
    tankMinTemp: 'Min temperatur',
    heatPumpType: 'Värmepumpstyp',
    nominalLoad: 'Nominell last',
    minimumLoad: 'Minimumlast',
    degradationCoefficient: 'Degraderingskoefficient',
    liquidSource: 'Vätskekälla',
    sourceTemperature: 'Källtemperatur',
    sourceYearlyAvgTemp: 'Källa årsmedeltemperatur',
    sourceTempAmplitude: 'Källtemperaturamplitud',
    copSourceTemp: 'Källtemp.',
    copMaxEffectLow: 'Max effekt (låg temp.)',
    copMaxEffectHigh: 'Max effekt (hög temp.)',
    copFullLoadLow: 'COP fullast (låg temp.)',
    copFullLoadHigh: 'COP fullast (hög temp.)',
    copNormalLoadLow: 'COP normallast (låg temp.)',
    copNormalLoadHigh: 'COP normallast (hög temp.)',
    copLowLoadLow: 'COP dellast (låg temp.)',
    copLowLoadHigh: 'COP dellast (hög temp.)',
    boilerType: 'Panntyp',
    efficiencyAtLowerLoad: 'Verkningsgrad vid dellast',
    effectAtFullLoad: 'Effekt vid fullast',
    isCondensing: 'Kondenserande',
    seasonalMeanTemperature: 'Säsongsmedeltemperatur',
    fuelSource: 'Bränslekälla',
    fuelEnergyContent: 'Bränsle energiinnehåll',
    fuelCo2EmissionFactor: 'Bränsle CO\u2082-emissionsfaktor',
    operatingStart: 'Driftstart',
    operatingEnd: 'Driftstopp',
    phi: 'Phi',
    insulationGrade: 'Isoleringsgrad',
    tilt: 'Lutning',
    collectorArea: 'Solfångararea',
    pipeLength: 'Rörlängd',
    pipeUValue: 'Rör U-värde',
    efficiencyAtNormalConditions: 'Verkningsgrad vid normalförhållanden',
    heatLossLinearCoefficient: 'Värmeförlust linjärkoefficient',
    heatLossCoefficient: 'Värmeförlustkoefficient',
    fuelType: 'Bränsletyp',
    panelArea: 'Panelarea',
    nominalEfficiency: 'Nominell verkningsgrad',
    panelAngle: 'Panelvinkel',
    panelAzimuth: 'Panel azimut',
    inverterEfficiency: 'Växelriktarverkningsgrad',
    degradationLoss: 'Degraderingsförlust',
    inverterLoss: 'Växelriktarförlust',
    transmissionProduct: 'Transmissionsprodukt (0-1)',
    temperatureCoefficient: 'Temperaturkoefficient (%/°C)',
    incidentAngleModifier: 'Infallsvinkelmodifierare (0-1)',
    heatLossFactor: 'Värmeförlustfaktor',
    pvMountingType: 'Monteringstyp',
    windExposure: 'Vindexponering',
    pvCellType: 'Celltyp',
    heaterType: 'Varmvattenberedartyp',
    useNormedData: 'Använd normerade data',
    placementType: 'Placeringstyp',
    volume: 'Volym',
    setpointTemperature: 'Börvärdestemperatur',
    heatingElementPower: 'Värmeelement effekt',
    specificHeatLoss: 'Specifik värmeförlust',
    maxPowerDemand: 'Max effektbehov',
    usagePattern: 'Användningsmönster',
    heatContributionPercent: 'Värmebidragsprocent',
    distributionSystemType: 'Distributionssystemtyp',
    pipeSpecificLength: 'Specifik rörlängd',
    tapCyclesPerDay: 'Tappningscykler per dag',
    pipesInHeatedRoom: 'Rör i uppvärmt rum',
    specificPumpPower: 'Specifik pumpeffekt',
    pipeLinearUValue: 'Rör linjärt U-värde',
    avgTempOutsideHeatedRoom: 'Medeltemp. utanför uppvärmt rum',
    greyWaterRecovery: 'Gråvattenåtervinning',
    greyWaterEfficiency: 'Gråvattenverkningsgrad',
    greyWaterShare: 'Gråvattenandel',
    greyWaterConnectionLossFactor: 'Gråvatten anslutningsförlustfaktor',
    greyWaterPatternLossFactor: 'Gråvatten mönsterförlustfaktor',
    waterSystemQuality: 'Vattensystemkvalitet',
    pipeInsulationType: 'Rörisoleringstyp',
    spp: 'SPP',
    constantFlow: 'Konstant flöde',
    lengthOfPipe: 'Rörlängd',
    percentageInHeatedSpace: 'Andel i uppvärmt utrymme',
    avgTempOutsideHeatedSpace: 'Medeltemp. utanför uppvärmt utrymme',
    temperatureReturn: 'Returtemperatur',
    temperatureSupply: 'Framledningstemperatur',
    eligibleForHarvesting: 'Lämplig för energiåtervinning',
    medium: 'Medium',
    temperature: 'Temperatur',
    amount: 'Mängd',
    ductShape: 'Kanalform',
    diameter: 'Diameter',
    width: 'Bredd',
    height: 'Höjd',
    airSpeed: 'Lufthastighet',
  },

  actions: {
    ventilation: {
      pageTitle: 'Ventilation',
      ventilationUnits: 'Ventilationsaggregat',
      noHvacUnits:
        'Inga VVS-aggregat hittades. Lägg till VVS-aggregat i VVS-sektionen först.',
      usingUnits:
        'Använder {count} aktiverade ventilationsaggregat från byggnadsinspektion.',
      enableUnitsHint:
        'Aktivera ventilationsaggregat nedan för att inkludera dem i åtgärden.',
    },
    lighting: {
      pageTitle: 'Belysning',
      thermalZones: 'Termiska zoner',
      noZones:
        'Inga termiska zoner hittades. Lägg till termiska zoner i sektionen för termiska zoner först.',
      usingZones:
        'Använder {count} aktiverade termiska zon(er) för belysningsåtgärden.',
      enableZonesHint:
        'Aktivera termiska zoner nedan för att inkludera dem i belysningsåtgärden.',
      unit: 'W/m\u00B2',
      presenceControl: 'Närvarostyrning (belysning)',
      presenceControlLabel: 'Närvarostyrning:',
      presenceYes: 'Ja (faktor: {value})',
      presenceNo: 'Nej',
    },
    heating: {
      pageTitle: 'Uppvärmning & kylning',
      thermalZones: 'Termiska zoner',
      usingZones:
        'Använder {count} aktiverade termiska zon(er) för uppvärmningsåtgärden.',
      enableZonesHint:
        'Aktivera termiska zoner nedan för att inkludera dem i uppvärmningsåtgärden.',
      addNewSystem: 'Lägg till nytt system',
      addSystemDialogTitle: 'Lägg till nytt system',
      template: 'Mall',
      systemName: 'Systemnamn',
      priorityHelp: '1 = högsta prioritet',
      unnamed: 'Namnlös',
      chipNew: 'NY',
      chipRemoved: 'BORTTAGEN',
      chipModified: 'ÄNDRAD',
      remove: 'Ta bort',
      delete: 'Radera',
      confirmDelete: 'Är du säker på att du vill ta bort detta system?',
      undo: 'Ångra',
      noExistingSystems: 'Inga befintliga värme-/kylsystem i denna zon.',
      enableZoneHint:
        'Aktivera denna zon för att konfigurera värme-/kylsystem.',
      existingSystems: '{count} befintligt/a system',
      templateAirWaterHP: 'Luft/vatten-värmepump',
      templateAirAirHP: 'Luft/luft-värmepump',
      templateAirToAirHP: 'Luft/luft-värmepump',
      templateGroundSourceHP: 'Bergvärmepump',
      templateElectricBoiler: 'Elpanna',
      templateDistrictHeating: 'Fjärrvärme',
      templateDistrictCooling: 'Fjärrkyla',
    },
    solar: {
      pageTitle: 'Solceller',
      solarPvModules: 'Solcellsmoduler',
      noModules:
        'Inga solcellsmoduler hittades. Lägg till solcellsmoduler i Solceller-sektionen först.',
      usingModules:
        'Använder {count} aktiverade solcellsmodul(er) från byggnadsinspektionen.',
      enableModulesHint:
        'Aktivera solcellsmoduler nedan för att inkludera dem i åtgärden.',
      addNewModule: 'Lägg till ny modul',
      chipNew: 'Ny',
      noExistingModules: 'Inga befintliga solcellsmoduler.',
    },
    control: {
      pageTitle: 'Styrning & Reglering',
      energyReductionPercent: 'Energireduktion [%]',
      energyReductionHint:
        'Procentuell minskning av total levererad energi från referenssimulering.',
    },
    overview: {
      overviewTitle: 'Åtgärdsöversikt',
      combinedResults: 'Kombinerade simuleringsresultat',
      notSimulated: 'Inte simulerad ännu',
      noActiveActions:
        'Inga aktiva åtgärder. Aktivera åtgärder på de enskilda åtgärdssidorna.',
      activeActions: 'Aktiva åtgärder',
      runCombinedSimulation: 'Kör byggsimulering',
      noUnitsSelected: 'Inga aggregat valda',
      noZonesSelected: 'Inga termiska zoner valda',
      noModulesSelected: 'Inga moduler valda',
      totalInvestment: 'Total investering',
      priorityUpdateFailed: 'Kunde inte uppdatera prioritet',
    },
  },

  scenarioSync: {
    outOfSync:
      'Inspektionen har ändrats sedan detta scenario senast synkroniserades.',
    legacyOutOfSync:
      'Inspektionen har ändrats sedan detta scenario skapades. Scenariot är äldre än synkroniseringsstödet, så skapa ett nytt scenario för att få med de senaste ändringarna.',
    reviewChanges: 'Granska ändringar',
    notSet: 'Ej angivet',
    items: 'poster',
    dialogTitle: 'Uppdatera scenario från inspektionen',
    dialogIntro:
      'Ändringar från inspektionen tas in automatiskt och dina egna ändringar i scenariot behålls. Där båda har ändrat samma fält väljer du vilket värde som ska gälla.',
    conflictsHeading: 'konflikter behöver din granskning',
    noConflicts: '0 konflikter',
    added: 'Ny',
    removed: 'Borttagen',
    removedInScenario: 'Raderad i detta scenario, raderingen behålls',
    removeConflict: 'Raderad i inspektionen, men ändrad i detta scenario',
    keepEntity: 'Behåll',
    removeEntity: 'Radera',
    keepScenario: 'Behåll scenariots värde',
    takeParent: 'Använd inspektionens värde',
    keptOverrides:
      'fält behåller dina ändringar från scenariot (uppdateringen skriver inte över dem)',
    noChanges: 'Inga skillnader att synkronisera.',
    markSynced: 'Markera som synkroniserad',
    applySync: 'Uppdatera scenariot',
    syncSuccess: 'Scenariot har uppdaterats från inspektionen',
    syncError: 'Kunde inte synkronisera scenariot',
    resimulateHint:
      'Kör simuleringen igen efteråt för att uppdatera resultaten.',
    collections: {
      inspection: 'Inspektion',
      thermalZones: 'Zoner',
      exteriorWalls: 'Ytterväggar',
      windowAreas: 'Fönster',
      doorAreas: 'Dörrar',
      gateAreas: 'Portar',
      operationalLoads: 'Interna laster',
      thermalZoneLinks: 'Zonkopplingar',
      hvacUnits: 'Ventilationssystem',
      heatingCoolingModules: 'Värme och kyla',
      centralEnergyModules: 'Central energi',
      combustionBoilers: 'Förbränningspannor',
      districtHeatings: 'Fjärrvärme',
      electricBoilers: 'Elpannor',
      otherSources: 'Andra energikällor',
      solarTermals: 'Solvärme',
      heatPumps: 'Värmepumpar',
      productionEquipments: 'Produktionsutrustning',
      solarPvModules: 'Solceller',
      excessEnergyModules: 'Överskottsenergi',
      domesticHotWaters: 'Tappvarmvatten',
      actionModules: 'Åtgärder',
      pipeLinks: 'Rörkopplingar',
      batteries: 'Batterier',
    },
  },

  scenario: {
    intro:
      'Skapa en eller flera redigerbara kopior av denna inspektion. Ändra vad du vill i en kopia, kör sedan en simulering för att jämföra med originalet.',
    introExisting:
      'En scenariokopia av denna inspektion finns redan. Öppna den för att fortsätta redigera, eller börja om från originalets nuvarande tillstånd.',
    bannerNotice:
      'Scenario. Ändringar här påverkar inte den ursprungliga inspektionen.',
    createScenario: 'Skapa scenario',
    addScenario: 'Lägg till scenario',
    scenarioName: 'Scenarionamn',
    scenarioNamePlaceholder: 't.ex. Nytt ventilationssystem',
    unnamedScenario: 'Namnlöst scenario',
    creating: 'Skapar…',
    createNewScenario: 'Skapa nytt scenario',
    renameScenario: 'Redigera åtgärdens namn och prioritet',
    deleteScenario: 'Radera scenario',
    confirmDeleteScenario: 'Ta bort detta scenario?',
    working: 'Arbetar…',
    backToOriginal: 'Tillbaka till originalet',
    confirmReplace:
      'Ersätta det befintliga scenariot med en ny kopia av originalet? Det nuvarande scenariot kasseras.',
    createFailed: 'Kunde inte skapa scenario',
    replaceFailed: 'Kunde inte ersätta scenario',
    renameFailed: 'Kunde inte byta namn på scenariot',
    deleteFailed: 'Kunde inte radera scenariot',
    existingCreated: 'Skapat {date}',
    existingCreatedBy: 'Skapat {date} av {name}',
    generalNotes: 'Allmänna anteckningar',
    generalNotesPlaceholder:
      'Förklara åtgärden så detaljerat som möjligt: vad som konkret ändrades och varför.',
    notesRequired: 'Allmänna anteckningar krävs',
    investmentCost: 'Investeringskostnad [NOK]',
    runToCompare: 'Kör scenariosimulering för att jämföra',
    savingsUnavailable:
      'Besparingar kunde inte beräknas ännu. Prisdata saknas eller är ofullständig.',
    compareLeftLabel: 'Original',
    compareRightLabel: 'Scenario',
    compareAgainst: 'Jämför med',
    noComparison: 'Ingen jämförelse',
    actionTypeLabel: 'Åtgärdstyp',
    selectActionType: 'Välj åtgärdstyp',
    actionTypes: {
      buildingShell: 'Byggnadsskal',
    },
  },

  report: {
    dragDropHint: 'Ändra ordning på kapitel och fält i sidomenyn.',
    generateReport: 'Generera rapport',
    reportLanguage: 'Rapportspråk',
    addChapter: 'Lägg till kapitel',
    exportToWord: 'Exportera till Word',
    exportingToWord: 'Exporterar till Word...',
    exportingProgress: 'Exporterar till Word — {current} av {total}: {label}',
    sources: 'Källor',
    noChapters: 'Inga kapitel ännu. Lägg till ett kapitel för att komma igång.',
    editTitle: 'Redigera titel',
    removeChapter: 'Ta bort kapitel',
    noFields: 'Inga textfält ännu. Lägg till ett fält för att börja.',
    fieldTitlePlaceholder: 'Titel på nytt fält...',
    addField: 'Lägg till fält',
    confirmRemoveChapter: 'Ta bort kapitel "{title}"?',
    generateWithAI: 'Generera med AI',
    hideAuditLog: 'Dölj revisionslogg',
    showAuditLog: 'Visa revisionslogg',
    removeField: 'Ta bort fält',
    promptLabel: 'Prompt (används för AI-generering)',
    promptPlaceholder: 'Skriv instruktioner för AI-generering...',
    generateText: 'Generera text',
    textPlaceholder: 'Skriv innehåll här, eller använd AI-generering',
    confirmRemoveField: 'Ta bort fält "{title}"?',
    addChapterTitle: 'Lägg till nytt kapitel',
    chapterTitleLabel: 'Kapiteltitel',
    chapterTitlePlaceholder: 'T.ex. Inomhusklimat och komfort',
    fetchError: 'Kunde inte hämta rapport',
    saveError: 'Kunde inte spara rapport',
    generateError: 'Kunde inte generera text',
    generatingStatus:
      'Rapporten genereras av AI. Det kan ta flera minuter — sidan uppdateras automatiskt när den är klar.',
    generateSuccess: 'Rapporten har genererats',
    generateTimeout:
      'Rapportgenerering avbröts på grund av tidsgräns. Tjänsten kan fortfarande bearbeta — försök att uppdatera sidan senare.',
    noContent:
      'Inget innehåll ännu. Generera rapporten eller lägg till text för att se en förhandsgranskning.',
    generationPromptLog: 'Genererad med prompt:',
  },
};

export default BUILDING_INSPECTION;
